import React from 'react';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { ContenedorForm, HeaderForm, CuerpoForm, TituloForm,Row,ContainerCol  } from '../componentes_generales/componentes_formulario/contenedores/';
import { Label, } from '../../componentes/componentes_generales/componentes_formulario/labels/';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import moment from 'moment';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import global_axios  from '../../funciones_globales/interaccionapi';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import '@trendmicro/react-toggle-switch/dist/react-toggle-switch.css';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { cargarCatalogosGenericoAsync,generarItemCatalogoSeleccionado} from '../../funciones_globales/catalogos';
import { esEmailValido } from '../../funciones_globales/utils';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import {  formatearNumeroEntero,completar_String,formatearNumeroDecimal } from '../../funciones_globales/format';
import { multiplicarDecimales } from '../../funciones_globales/operacionesMatematicas';
import { obtenerParametros } from '../../funciones_globales/parametros';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import { validarCampoString } from '../../funciones_globales/utils';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';


const isSmartPhone = navigator.userAgent.match(/Android/i)
|| navigator.userAgent.match(/webOS/i)
|| navigator.userAgent.match(/iPhone/i)
|| navigator.userAgent.match(/iPad/i)
|| navigator.userAgent.match(/iPod/i)
|| navigator.userAgent.match(/BlackBerry/i)
|| navigator.userAgent.match(/Windows Phone/i)?true : false

const staticHeight= 35

const staticFontSize = 13
const LabelFormCustom = styled.label`
    display: inline-block;
    font-size: 15px;
    @media(min-width: 800px){
        margin-left: ${props => props.margen_izq?props.margen_izq:'0'}px;
    }
    color: ${props => props.color?props.color:'black'};
    margin-top: ${props => props.margen_arriba?props.margen_arriba:'0'}px;
    margin-bottom: ${props => props.margen_abajo?props.margen_abajo:'0'}px;
`;

const ContainerAlineado = styled.div`
  display: inline;
`;

const LabelCabecera = styled.label`
  display: inline;
  font-size: 9px;
  color: green;
  margin-right: 15px;
  float: right;
`;

const LabelTotales = styled.label`
	display: inline-block;
	font-size: 12px;
	color: green;
`;
const LabelValorTotales = styled.label`
	display: inline-block;
	font-size: 12px;
	font-weight: bold;
	align-text: right;
`;
const ModalContainer = styled.div`
	margin-top: 30px;
	height:${!isSmartPhone?'350px':'250px'} ;
	width: ${!isSmartPhone?'650px':'350px'};
`;

const ModalContainerSmall = styled.div`
	margin-top: 30px;
	height: 100px;
	width: 190px;
`;
// const LabelTipoProf = styled.label`
//   display: inline;
//   font-size: 10px;
//   color: green;    
// `;
const Hr = styled.hr`
	margin-top: 10px;
	margin-bottom: 10px;
`;
const PaginationLabels = styled.div`
    font-size: 12px;
`;

const PaginationButtons = styled.div`
    margin-bottom:10px;
`;
// const ValueForm = styled.span`
// 	display: inline-block;
// 	font-size: 12px;
// `;
const ContenedorBoton = styled.div`
  padding-top: 17px;  
  @media (max-width: 991px) {
    padding-top: 0px;
  }
`;
class FormVende02  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            observacionDescription:'',
            fechaProcesoString:'',
            articuloSearch:'',
            isModalFotosVisible:false,
            currentImageIndex:0,
            artImages:[],
            isModalDescripcionVisible:false,
            modificaPedido:false,
            stockDisponibleModal:0,
            referencia:'',
            observacion:'',
            articuloPrecioDescuentoLinea:0,
            articuloMarca:'',
            articuloName:'',
            articulosSustitutos:[],
            secuencialDireccion:null,
            transitoCantidad:0,
            totalChqPendiente:0,
            detalleChqPendiente:[],
            email:'',
            currentStock:0,
            controlCupoStatus:'',
            ultimosVendidos:[],
            isModalDetalleUltimosVendidosVisible:false,
            totalDsctoLinea: parseFloat(0.00),   
            porcentajeDsctoPlazo:0,
            totalDsctoPlazo:0,
            listaPrecioCliente:'',
            formaPago:[],
            statusForm:'N',
            pedidoSeleccionado:'',
            pedidoId:'',
            ultimoPedido:'',
            valorSubTotal:parseFloat(0.00),
            subtotalConIva: parseFloat(0.00),
            subtotalSinIva: parseFloat(0.00),
            total: parseFloat(0.00),
            valorIva: parseFloat(0.00),
            totalDscto: parseFloat(0.00),      
            totalReserva:parseFloat(0.00),
            isModalDetalleVisible:false,
            isModalDetalleTotalVencidoVisible:false,
            isModalDetalleChequePendienteVisible:false,
            detallePedidosReserva:[],
            porcentIva: parseFloat(0.00),
            porcentajeDscto: parseFloat(0.00),
            cantidad_ingresada:0,
            cliente_sel:null,
            tipoCliente_sel: null, 
            vendedor_sel: null, 
            direccion_sel: null, 
            articulo_sel:null,
            articulo_data:null,
            terminoPago_sel: null,
            formaPago_sel: null,
            detalleProforma: [],
            terminosPago: [],
            cupo:0,
            cupoDisponible:0,//ES EL RIESGO CLIENTE
            totalVencido:0,
            detalleTotalVencido:[],
            paginationSustituto: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
            pagination: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
            paginationDetTotalVencido: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
            paginationDetChequePendiente: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
            paginationUltimosVendidos: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
            colDetalleTotalVencido:[
                {   header: "Documento",
                    field: "Docm",
                    width: 70,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
                {   header: "Número",
                    field: "Factura",
                    width: 70,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },                          
                {   header: "Vendedor",
                    field: "Vendedor",
                    width: 130,
                    type: "string" ,
                    cellStyle: { 'font-size': `${staticFontSize}px`}                              
                },
                { header: 'Fch. Factura',
                    field: 'FechaFac',
                    width: 77,
                    type: 'string'  ,
                    cellStyle: { 'font-size': `${staticFontSize}px`}          
                },
                { header: 'Fch. Despacho',
                    field: 'FechaDespacho',
                    width: 77,
                    type: 'string'  ,
                    cellStyle: { 'font-size': `${staticFontSize}px`}          
                },
                {   header: "Vencimiento",
                    field: "Vencimiento",
                    width: 77,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
                {   header: "Días Vencido",
                    field: "DiasVencido",
                    width: 77,
                    type: "num_entero",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
                {   header: "Importe",
                    field: "Importe",
                    width: 77,
                    type: "num_decimal",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
                {   header: "Saldo",
                    field: "saldo",
                    width: 77,
                    type: "num_decimal",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
                {   header: "Vencido",
                    field: "Vencido",
                    width: 77,
                    type: "num_decimal",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
            ],
            colDetalleChequePendiente:[
                {   header: "Banco",
                    field: "Banco",
                    width: 70,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
                {   header: "Cuenta",
                    field: "Cuenta",
                    width: 70,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },                          
                {   header: "Cheque",
                    field: "cheque",
                    width: 130,
                    type: "string" ,
                    cellStyle: { 'font-size': `${staticFontSize}px`}                              
                },
                { header: 'Fch. Ingreso',
                    field: 'F_Ingreso',
                    width: 77,
                    type: 'string' ,
                    cellStyle: { 'font-size': `${staticFontSize}px`}           
                },
                { header: 'Fch. Vencimiento',
                    field: 'F_Vencimiento',
                    width: 77,
                    type: 'string' ,
                    cellStyle: { 'font-size': `${staticFontSize}px`}       
                },
                {   header: "Valor Cheque",
                    field: "ValorCheque",
                    width: 77,
                    type: "num_decimal",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
                {   header: "Saldo",
                    field: "Saldo",
                    width: 77,
                    type: "num_decimal",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                }
            ],

            colDetallePedidosReserva:[
                {   header: 'No.',
                    field: 'NroItem',
                    width: 35,
                    type: 'string',
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
                {   header: "Pedido",
                    field: "Pedido",
                    width: 70,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
                {   header: "Fch.",
                    field: "Fecha",
                    width: 90,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },                          
                {   header: "Cliente",
                    field: "Nombre",
                    width: 260,
                    type: "string" ,
                    cellStyle: { 'font-size': `${staticFontSize}px`}                             
                },
                { header: 'Cantidad',
                    field: 'Cantidad',
                    width: 77,
                    type: 'num_entero' ,
                    cellStyle: { 'font-size': `${staticFontSize}px`}       
                },
                {   header: "Origen",
                    field: "origen",
                    width: 100,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
            ],
            colDetalleSustitutos:[
                {   header: "Art.",
                    field: "articulo",
                    width: 70,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
                {   header: "Nombre",
                    field: "nombre",
                    width: 280,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },  
                {   header: "Precio",
                    field: "Precio",
                    width: 80,
                    type: "num_decimal",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },                           
                {   header: "Referencia",
                    field: "referencia",
                    width: 130,
                    type: "string" ,
                    cellStyle: { 'font-size': `${staticFontSize}px`}                          
                },
                { header: 'Marca',
                    field: 'Marca',
                    width: 77,
                    type: 'string' ,
                    cellStyle: { 'font-size': `${staticFontSize}px`}          
                },
            
                {   header: "País Origen",
                    field: "PaisOrigen",
                    width: 100,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
                {   header: "Observacion",
                    field: "observacion",
                    width: 390,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
            ],
            colDetalleUltimosVendidos:[
                {   header: "Factura",
                    field: "Factura",
                    width: 70,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
                {   header: "Fch.",
                    field: "FechaTransaccion",
                    width: 70,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },                          
                {   header: "Cantidad",
                    field: "Cantidad",
                    width: 77,
                    type: 'num_entero',
                    cellStyle: { 'font-size': `${staticFontSize}px`}                                
                },
                { header: 'Devuelve',
                    field: 'Devuelve',
                    width: 77,
                    type: 'num_entero',
                    cellStyle: { 'font-size': `${staticFontSize}px`}          
                },
                { header: 'Precio',
                    field: 'Precio',
                    width: 77,
                    type: 'num_decimal',
                    cellStyle: { 'font-size': `${staticFontSize}px`}          
                },
                { header: 'Precio Neto',
                    field: 'PrecioNeto',
                    width: 77,
                    type: 'num_decimal',
                    cellStyle: { 'font-size': `${staticFontSize}px`}       
                },
                {   header: "Venta Neta",
                    field: "VentaNeta",
                    width: 100,
                    type: "num_decimal",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
                {   header: "% DsctoPlazo",
                    field: "%DsctoPlazo",
                    width: 77,
                    type: "num_decimal",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
                {   
                    header: "Vendedor",
                    field: "Vendedor",
                    width: 77,
                    type: "string",
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                },
            ],
           
            colsDefDetProforma: [
                { header: 'Artículo',
                  children: [
                    { header: 'No.',
                      field: 'NroItem',
                      width: 35,
                      type: 'string',
                      cellStyle: { 'font-size': `${staticFontSize}px`}
                    },
                    { header: 'Código.',
                      field: 'Articulo',
                      width: 65,
                      cellStyle: { 'font-size': `${staticFontSize}px`}
                    },
                  ]
                },
                { header: 'Stock',
                  children: [
                    { header: 'Disp.',
                      field: 'StockDisponible',
                      width: 58,
                      type: 'num_entero'  ,
                      cellStyle: { 'font-size': `${staticFontSize}px`}          
                    }
                  ]
                },
                { header: 'Pedido',
                children: [
                  { header: 'Ped.',
                    field: 'CantPorDespachar',
                    width: 45,
                    type: 'num_entero_edit',
                    editable: true,
                    cellStyle: { 'font-size': `${staticFontSize}px`}
                  },
                  { header: 'Vend.',
                    field: 'Vendido',
                    width: 45,
                    type: 'num_entero_edit',
                    cellStyle:{ backgroundColor: '#b3ecff','font-size': `${staticFontSize}px`},
                    
                
                  },
                  {   header: 'P. Unit.',
                      field: 'PrecioUnit',
                      width: 70,
                      type: 'num_decimal3',   
                      cellStyle: { 'font-size': `${staticFontSize}px`}            
                  },
                  {  header: '% Dscto.',
                      field: 'Descuento',
                      width: 65,
                      type: 'num_decimal',
                      cellStyle: { 'font-size': `${staticFontSize}px`}          
                  },
                  { header: 'Total',
                      field: 'Total',
                      width: 65,
                      type: 'num_decimal',
                      cellStyle: { 'font-size': `${staticFontSize}px`},
                      valueGetter: (params) => {
                        /* Cálculo del subotal de cada item de la proforma, se considera el descuento por línea de artículo */
                        let cantidad = parseFloat(Number.isNaN(params.data.Vendido)? 0: params.data.Vendido);
                        let precioUnit = parseFloat(Number.isNaN(params.data.PrecioUnit)? 0: params.data.PrecioUnit);
                        let porcDescuento = parseFloat(Number.isNaN(params.data.Descuento)? 0: params.data.Descuento);
                        let porcDescuentoPlazo= this.state.porcentajeDsctoPlazo;

                        let precioUnitDsctoPlazo=  parseFloat(multiplicarDecimales(precioUnit, porcDescuentoPlazo/100));
                        let precioUnitDescontadoPlazo = parseFloat(parseFloat(precioUnit)-parseFloat(precioUnitDsctoPlazo));

                        let precioUnitDscto = parseFloat(multiplicarDecimales(precioUnitDescontadoPlazo, porcDescuento/100));
                        let precioUnitDescontado = parseFloat(parseFloat(precioUnitDescontadoPlazo)-parseFloat(precioUnitDscto)); 
                        let subTotalItem = parseFloat(multiplicarDecimales(cantidad, precioUnitDescontado)).toFixed(2);
                        
                        
                        return subTotalItem;
                      }
                   },
                   {  header: 'Marca',
                      field: 'Marca',
                      width: 50,
                      type: 'string'              
                  },
                ]
              },
            ],
        };
        this.gridDetUltimosVendidosOptions = {
            context: {
                componentParent: this
            },
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
            rowSelection: "single",
            paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
            suppressScrollOnNewData: true,

            onPaginationChanged: () => {
                
                if(!this.gridDetUltimosVendidosApi){
                    return;
                }
                let totalFilas = this.gridDetUltimosVendidosApi.paginationGetRowCount();
                let totalFilasPorPagina = this.gridDetUltimosVendidosApi.paginationGetPageSize();
                let ultimaFilaPagina = (totalFilasPorPagina * (this.gridDetUltimosVendidosApi.paginationGetCurrentPage()+1));
                let indexPage = this.gridDetUltimosVendidosApi.paginationGetCurrentPage();

                if( ultimaFilaPagina >  totalFilas){
                    ultimaFilaPagina = totalFilas;
                }
           
                let pagination = {
                    totalFilas: totalFilas,
                    totalFilasPorPagina: totalFilasPorPagina,
                    primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
                    ultimaFilaPagina: ultimaFilaPagina
                };

                this.setState({paginationUltimosVendidos:pagination},  ()=>this.setStateToLocalStorage(this.state));
			},
        };
        this.gridDetTotalVencidoOptions = {
            context: {
                componentParent: this
            },
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
            rowSelection: "single",
            paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
            suppressScrollOnNewData: true,

            onPaginationChanged: () => {
                
                if(!this.gridDetTotalVencidoApi){
                    return;
                }
                let totalFilas = this.gridDetTotalVencidoApi.paginationGetRowCount();
                let totalFilasPorPagina = this.gridDetTotalVencidoApi.paginationGetPageSize();
                let ultimaFilaPagina = (totalFilasPorPagina * (this.gridDetTotalVencidoApi.paginationGetCurrentPage()+1));
                let indexPage = this.gridDetTotalVencidoApi.paginationGetCurrentPage();

                if( ultimaFilaPagina >  totalFilas){
                    ultimaFilaPagina = totalFilas;
                }
           
                let pagination = {
                    totalFilas: totalFilas,
                    totalFilasPorPagina: totalFilasPorPagina,
                    primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
                    ultimaFilaPagina: ultimaFilaPagina
                };

                this.setState({paginationDetTotalVencido:pagination}, ()=>  this.setStateToLocalStorage(this.state));
			},
        };
        this.gridDetChequePendienteOptions = {
            context: {
                componentParent: this
            },
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
            rowSelection: "single",
            paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
            suppressScrollOnNewData: true,

            onPaginationChanged: () => {
                
                if(!this.gridDetChequePendienteApi){
                    return;
                }
                let totalFilas = this.gridDetChequePendienteApi.paginationGetRowCount();
                let totalFilasPorPagina = this.gridDetChequePendienteApi.paginationGetPageSize();
                let ultimaFilaPagina = (totalFilasPorPagina * (this.gridDetChequePendienteApi.paginationGetCurrentPage()+1));
                let indexPage = this.gridDetChequePendienteApi.paginationGetCurrentPage();

                if( ultimaFilaPagina >  totalFilas){
                    ultimaFilaPagina = totalFilas;
                }
           
                let pagination = {
                    totalFilas: totalFilas,
                    totalFilasPorPagina: totalFilasPorPagina,
                    primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
                    ultimaFilaPagina: ultimaFilaPagina
                };

                this.setState({paginationDetChequePendiente:pagination}, ()=>  this.setStateToLocalStorage(this.state));
			},
        };
        this.gridDetSustitutoOptions = {
            context: {
                componentParent: this
            },
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
            rowSelection: "single",
            paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
            suppressScrollOnNewData: true,

            getRowStyle: (params) =>{
                if (params.data.tipo === 'P') {
                  return {'background-color': '#FAFAD2'}
                }
                return null;
            },
            onPaginationChanged: () => {
                if(!this.gridDetSustitutoApi){
                    return;
                }
                let totalFilas = this.gridDetSustitutoApi.paginationGetRowCount();
                let totalFilasPorPagina = this.gridDetSustitutoApi.paginationGetPageSize();
                let ultimaFilaPagina = (totalFilasPorPagina * (this.gridDetSustitutoApi.paginationGetCurrentPage()+1));
                let indexPage = this.gridDetSustitutoApi.paginationGetCurrentPage();

                if( ultimaFilaPagina >  totalFilas){
                    ultimaFilaPagina = totalFilas;
                }
           
                let pagination = {
                    totalFilas: totalFilas,
                    totalFilasPorPagina: totalFilasPorPagina,
                    primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
                    ultimaFilaPagina: ultimaFilaPagina
                };

                this.setState({paginationSustituto:pagination}, ()=>  this.setStateToLocalStorage(this.state));
			},
        };
        this.gridDetProformaReservaOptions = {
            context: {
                componentParent: this
            },
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
            rowSelection: "single",
            paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
            suppressScrollOnNewData: true,

            getRowStyle: (params) =>{
                if (params.data.tipo === 'P') {
                  return {'background-color': '#FAFAD2'}
                }
                return null;
            },
            onPaginationChanged: () => {
                if(!this.gridDetProformaReservaArticuloApi){
                    return;
                }
                let totalFilas = this.gridDetProformaReservaArticuloApi.paginationGetRowCount();
                let totalFilasPorPagina = this.gridDetProformaReservaArticuloApi.paginationGetPageSize();
                let ultimaFilaPagina = (totalFilasPorPagina * (this.gridDetProformaReservaArticuloApi.paginationGetCurrentPage()+1));
                let indexPage = this.gridDetProformaReservaArticuloApi.paginationGetCurrentPage();

                if( ultimaFilaPagina >  totalFilas){
                    ultimaFilaPagina = totalFilas;
                }
           
                let pagination = {
                    totalFilas: totalFilas,
                    totalFilasPorPagina: totalFilasPorPagina,
                    primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
                    ultimaFilaPagina: ultimaFilaPagina
                };

                this.setState({pagination}, ()=>  this.setStateToLocalStorage(this.state));
			},
        };
        this.gridDetProformaOptions = {
            context: {
                componentParent: this
            }, 
            enableColResize: true,
            enableCellChangeFlash: true,
            

            onRowDataChanged: ((event)=>{
              /* Cada vez que el grid de detalle sufra un cambio se recalcularán los totales*/
              this.calculoTotales();
            }),
            onCellDoubleClicked: ((event)=>{        
                if(event.column.colId==='Articulo' ){
                    let documento = event.data;
                   //MOSTRAR MODAL
                   this.setState({
                       isModalDescripcionVisible:true,
                       descripcionArt : documento.Descripcion,
                       observacion: documento.observacion,
                       referencia: documento.referencia
                   }, ()=>  this.setStateToLocalStorage(this.state))
                }
            }),
            
            rowSelection: 'single',
            rowDeselection: 'true',
            singleClickEdit: true,
            onCellValueChanged: ((event)=>{
              let eventData = { valorAnterior: formatearNumeroEntero(event.oldValue),
                                valorNuevo: formatearNumeroEntero(event.newValue),
                                itemProforma: event.data
                              };
              
              let columna = event.colDef.field;
              /* Actualización de la reserva de stock en caso de que se modifique la cantidad a pedir de un artículo */
              if (columna === 'CantPorDespachar'){
                if(isNaN(eventData.valorNuevo) || formatearNumeroEntero(eventData.valorNuevo)<0){
                  event.data.CantPorDespachar = eventData.valorAnterior;
                }else{
                  if(parseInt(event.data.CantPorDespachar,10) === 0){
                      alert('No puede ingresar una cantidad de 0')
                      event.data.CantPorDespachar = eventData.valorAnterior;
                      
                  }
                  event.data.Vendido = parseInt(event.data.CantPorDespachar,10) > parseInt(event.data.StockDisponible,10)? parseInt(event.data.StockDisponible,10) : parseInt(event.data.CantPorDespachar,10) ;
                }
                this.gridDetProformaApi.refreshCells();
                this.calculoTotales()
              }
              
            }),
      
            onCellEditingStarted: ((event)=>{
              /* Control para no permitir la modificación de una proforma */
              if (this.state.operacion==='M' && this.state.esModificable===false){
               this.gridDetProformaApi.stopEditing(true);
                alert('La modificación de este pedido no está permitida.');
                return;
              }
      
            //   if (!event.data.EsEditable){          
            //     this.gridDetProformaApi.stopEditing(true);
            //     alert('La modificación de este artículo no está permitida.');
            //     return;
            //   }
            }),
      
           
      
            suppressScrollOnNewData: true
      
        };
        this.changeModificaPedido = this.changeModificaPedido.bind(this)
        this.generarConsultaDetalleArticuloPedidoInalambrikItera = this.generarConsultaDetalleArticuloPedidoInalambrikItera.bind(this)
        this.generarConsultaUltimosVendidos = this.generarConsultaUltimosVendidos.bind(this)
        this.generarConsultaDetalleTotalVencido = this.generarConsultaDetalleTotalVencido.bind(this)
        this.generarConsultaDetalleChequePendiente = this.generarConsultaDetalleChequePendiente.bind(this)
        this.getClientebyId = this.getClientebyId.bind(this);
        this.onGridDetProformaReady = this.onGridDetProformaReady.bind(this);
        this.onGridDetalleProformaReservaArticuloReady= this.onGridDetalleProformaReservaArticuloReady.bind(this);
        this.onGridDetalleSustitutoReady= this.onGridDetalleSustitutoReady.bind(this);
        this.onGridDetalleTotalVencidoReady = this.onGridDetalleTotalVencidoReady.bind(this)
        this.onGridDetalleChequePendienteReady = this.onGridDetalleChequePendienteReady.bind(this)
        this.onGridDetalleUltimosVendidosReady = this.onGridDetalleUltimosVendidosReady.bind(this)
        this.addArticulo = this.addArticulo.bind(this);
        this.buscarStockArticulos = this.buscarStockArticulos.bind(this);
        this.immutablePush = this.immutablePush.bind(this);
        this.immutableDelete = this.immutableDelete.bind(this);
        this.seleccionarArticulo= this.seleccionarArticulo.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDeleteArticulo = this.handleDeleteArticulo.bind(this)
        this.generarConsultaDetalleArticuloPedido = this.generarConsultaDetalleArticuloPedido.bind(this)
        this.limpiar=this.limpiar.bind(this)
        this.limpiar2 = this.limpiar2.bind(this)
        this.anularPedido = this.anularPedido.bind(this)
        this.guardarPedido = this.guardarPedido.bind(this)
        this.getPedidoById= this.getPedidoById.bind(this)
        this.getFormasDePago = this.getFormasDePago.bind(this)
        this.getTerminosDePago = this.getTerminosDePago.bind(this)
        this.getSecuencialPedidoMovilItera = this.getSecuencialPedidoMovilItera.bind(this)
        this.completarNumeroComprob  = this.completarNumeroComprob.bind(this)   
        this.changeTerminoPago = this.changeTerminoPago.bind(this)
        this.changeFormaPago = this.changeFormaPago.bind(this);
        this.getControlCupoStatus = this.getControlCupoStatus.bind(this)
        this.changeCliente = this.changeCliente.bind(this)
        this.enviarPedido = this.enviarPedido.bind(this)
        this.showImagesModal = this.showImagesModal.bind(this)
        this.nextImage = this.nextImage.bind(this)
        this.previousImage = this.previousImage.bind(this)
        this.getOptions_Articulos = this.getOptions_Articulos.bind(this)
        this.setStateToLocalStorage = this.setStateToLocalStorage.bind(this)
    }
    changeModificaPedido(){
        this.setState({
            modificaPedido:!this.state.modificaPedido
        })
        
    }
    showImagesModal(){
        this.setState({
            isModalFotosVisible:true,
        })
    }
    changeFormaPago(value){
        console.log("CHANGE FORMA DE PAGO", value)
        this.setState({formaPago_sel: value!==null?value.value:null},
            ()=>this.setStateToLocalStorage(this.state));
        this.changeTerminoPago(null);
    }

    changeTerminoPago(value){
        let porcentajeDsctoPlazo=0;
        console.log("ChangeTerminoPago", value)
        if(value!=null){
            if(this.state.formaPago_sel && this.state.formaPago_sel.trim() === 'CN'  && value.TerminoPagoId.trim() !== '01'){
                alert('Al ser forma de pago contado solamente se puede seleccionar el termino de pago 0 a 30 días')
                return
            }
        }
       
        porcentajeDsctoPlazo = value!==null?value.descuento:0
        this.setState({terminoPago_sel: value!==null?value.value:null, porcentajeDsctoPlazo:porcentajeDsctoPlazo},()=>{
          if(this.state.detalleProforma.length>0){
            this.calculoTotales();
            this.gridDetProformaApi.refreshCells();
          }
          this.setStateToLocalStorage(this.state)
          
        
        })
    }
    completarNumeroComprob(){
        let numeroComprobante = this.state.pedidoId;
        numeroComprobante =((numeroComprobante.length<6 && numeroComprobante.length>0)?completar_String(numeroComprobante, '0', 6):numeroComprobante);
        this.setState({pedidoId:numeroComprobante}, ()=>  this.setStateToLocalStorage(this.state))      
    }
    enviarPedido(){
        let mensaje = window.confirm(`¿Esta seguro de enviar el pedido ?`);
        if(mensaje){
             //Se comprueba que se tenga seleccionado un cliente
            //Se comprueba que el grid tenga artículos
            //Se comprueba que el formulario tenga seleccionada una forma de pago.
            //Se comprueba que el formulario en caso de ser una forma de pago distinta de efectivo se pedira que tenga seleccionado un termino de pago.
            const email = value =>
            value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
            false : true;
            let puedeGuardar=true;
            if(this.state.cliente_sel===null || this.state.cliente_sel===''){
                alert('Seleccione un cliente para continuar...')
                puedeGuardar=false;
                return
            }
            if(this.state.email===null || this.state.email===''){
                alert('El cliente no posee un email, para continuar ingrese el email en la caja de texto correspondiente...')
                puedeGuardar=false;
                return
            }
            //Validacion email valido
            if(!email(this.state.email)){
                alert('El email ingresado es invalido...')
                puedeGuardar=false;
                return
            }
            if(this.state.detalleProforma.length===0){
                alert('Debe ingresar artículos para continuar...')
                puedeGuardar=false;
                return
            }
            if(this.state.terminoPago_sel===null || this.state.terminoPago_sel===undefined)
            {
                alert('Debe seleccionar un termino de pago para continuar...')
                puedeGuardar=false;
                return
            }

        
            if(puedeGuardar){
                const empresa = JSON.parse(localStorage.empresaActual)
                //Se procede a enviar la data necesaria para procesar la transacción. guardar_pedido_movil
                let data= {};
                let nombre= this.state.cliente_sel.label.split('(')
                data.idPedido= this.state.pedidoId;
                data.Cliente = this.state.cliente_sel.value;
                data.NombreCliente= nombre[0];//buscar un substring hasta los parentesis.
                data.Fecha='';
                data.Vendedor= getItemDatosSesion('usuario');
                data.Nota= this.state.observacionDescription;
                data.Total_Factura=this.state.total;
                data.Fecha_Sistema ='';
                data.Iva = this.state.valorIva;
                data.Descuento = this.state.totalDsctoLinea;
                data.SubDescuento = this.state.subtotalConIva; 
                data.TerminoPago=this.state.terminoPago_sel;
                data.DetallePedido= this.state.detalleProforma;
                data.EsPedidoItera='S' 
                data.FormaPago = this.state.formaPago_sel
                data.EmpresaId =empresa.Id
                data.TotalVencido = this.state.totalVencido
                data.Cupo = this.state.cupo
                data.RiesgoCliente = this.state.cupoDisponible
                data.TotalDsctoPlazo = this.state.totalDsctoPlazo
                data.SecuencialDireccion = this.state.direccion_sel
                data.Email = this.state.email
                data.SendPedido=true
                data.DescuentoTPago = this.state.porcentajeDsctoPlazo
                
                this.props.cambiar_VisualizacionLoading(true)
                global_axios({
                    method: 'POST',
                    url: this.state.statusForm==='N'?'/pedidosmoviles/guardar_pedido_movil':'/pedidosmoviles/modificar_pedido_movil',
                    data:data
                    }).then((response)=>{
                        this.setState({
                            modificaPedido:false
                        }) 
                        this.limpiar2()
                        this.props.cambiar_VisualizacionLoading(false)
                        alert(response.data.msg)
                    }).catch((err)=>{
                        if(err.response.status === 420){
                            alert(err.response.data.msg)
                        }
                        this.props.cambiar_VisualizacionLoading(false)
                })
            }
        }
       
    }
    guardarPedido(){
        //Se comprueba que se tenga seleccionado un cliente
        //Se comprueba que el grid tenga artículos
        //Se comprueba que el formulario tenga seleccionada una forma de pago.
        //Se comprueba que el formulario en caso de ser una forma de pago distinta de efectivo se pedira que tenga seleccionado un termino de pago.
        const email = value =>
            value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
        false : true;
        let puedeGuardar=true;
        if(this.state.cliente_sel===null || this.state.cliente_sel===''){
            alert('Seleccione un cliente para continuar...')
            puedeGuardar=false;
            return
        }
        if(this.state.email===null || this.state.email===''){
            alert('El cliente no posee un email, para continuar ingrese el email en la caja de texto correspondiente...')
            puedeGuardar=false;
            return
        }
        //Validacion email valido
        if(!email(this.state.email)){
            alert('El email ingresado es invalido...')
            puedeGuardar=false;
            return
        }
        if(this.state.detalleProforma.length===0){
            alert('Debe ingresar artículos para continuar...')
            puedeGuardar=false;
            return
        }
        if(this.state.terminoPago_sel===null || this.state.terminoPago_sel===undefined)
        {
            alert('Debe seleccionar un termino de pago para continuar...')
            puedeGuardar=false;
             return
        }

       
        if(puedeGuardar){
            const empresa = JSON.parse(localStorage.empresaActual)
            //Se procede a enviar la data necesaria para procesar la transacción. guardar_pedido_movil
            let data= {};
            let nombre= this.state.cliente_sel.label.split('(')
            data.idPedido= this.state.pedidoId;
            data.Cliente = this.state.cliente_sel.value;
            data.NombreCliente= nombre[0];//buscar un substring hasta los parentesis.
            data.Fecha='';
            data.Vendedor= getItemDatosSesion('usuario');
            data.Nota= this.state.observacionDescription;
            data.Total_Factura=this.state.total;
            data.Fecha_Sistema ='';
            data.Iva = this.state.valorIva;
            data.Descuento = this.state.totalDsctoLinea;
            data.SubDescuento = this.state.subtotalConIva; 
            data.TerminoPago=this.state.terminoPago_sel;
            data.DetallePedido= this.state.detalleProforma;
            data.EsPedidoItera='S' 
            data.FormaPago = this.state.formaPago_sel
            data.EmpresaId =empresa.Id
            data.TotalVencido = this.state.totalVencido
            data.Cupo = this.state.cupo
            data.RiesgoCliente = this.state.cupoDisponible
            data.TotalDsctoPlazo = this.state.totalDsctoPlazo
            data.SecuencialDireccion = this.state.direccion_sel
            data.Email = this.state.email
            data.SendPedido = false
            data.DescuentoTPago = this.state.porcentajeDsctoPlazo
            this.props.cambiar_VisualizacionLoading(true)
            global_axios({
                method: 'POST',
                url: this.state.statusForm==='N'?'/pedidosmoviles/guardar_pedido_movil':'/pedidosmoviles/modificar_pedido_movil',
                data:data
                }).then((response)=>{
                    this.setState({
                        modificaPedido:false
                    }) 
                    this.limpiar2()
                    this.props.cambiar_VisualizacionLoading(false)
                    alert(response.data.msg)
                }).catch((err)=>{
                    if(err.response.status === 420){
                        alert(err.response.data.msg)
                    }
                    this.props.cambiar_VisualizacionLoading(false)
                })
        }
    }
    anularPedido(){
        var pedidoSeleccionado=this.state.pedidoId;
        let mensaje = window.confirm(`¿Esta seguro de eliminar el pedido número `+pedidoSeleccionado +' ?');
        if(mensaje){  
          
            this.props.cambiar_VisualizacionLoading(true);
            let query = "?id="+pedidoSeleccionado
            global_axios({
            method: 'GET',
            url: '/pedidosmoviles/anular/pedido/de/itera/id'+query
            }).then((response)=>{ 
                alert('Pedido Número '+pedidoSeleccionado+' anulado con exito.')
                this.setState({
                    modificaPedido:false
                }) 
                this.limpiar2();
                this.props.cambiar_VisualizacionLoading(false)
            }).catch((err)=>{
                this.props.cambiar_VisualizacionLoading(false)
                const errm = err!==null && err !==undefined ? 
                    err.response !== null && err.response !== undefined ? 
                    err.response.data!== null && err.response.data!== undefined?   err.response.data.msg : '' : '' : ''
                alert( errm)
            })
        }
        
    }
    //Funcion que recibe parametros de la fila para eliminar
    methodFromParent(id, datos_fila){
       
        // var mensaje;
        // if(datos_fila.hasOwnProperty('num_cuenta') && datos_fila.hasOwnProperty("descripcion_Cuenta")){
        //     mensaje = window.confirm("¿Desea eliminar el registro?"); 
           
        //     if (mensaje){
        //         if(datos_fila.hasOwnProperty('tipo')){
        //             this.abrirModalGasto();
        //         }else{
        //             this.eliminarAsiento(datos_fila ,id) 
        //         }
              
        //     }
        // }

        // if(datos_fila.hasOwnProperty('porcentaje') && datos_fila.hasOwnProperty("base_calculo")){
        //     mensaje = window.confirm("¿Desea eliminar el registro?"); 
            
        //     if (mensaje && this.state.operacion === 'G'){
        //         this.eliminarRetencion(datos_fila ,id) 
        //     }else{
        //         alert("No se permite modificar este movimiento")
        //     }
        // }

        // if(datos_fila.hasOwnProperty('ID_ANTICIPO') && datos_fila.hasOwnProperty("COMPRA")){
        //     mensaje = window.confirm("¿Desea eliminar el registro?"); 

        //     if (mensaje){
        //         this.eliminarAnticiposAplicados(datos_fila ,id) 
        //     }
        // }

    }
    generarConsultaDetalleArticuloPedido(art){
        this.props.cambiar_VisualizacionLoading(true);
        let query = "?articulo="+art.Articulo
        global_axios({
        method: 'GET',
        url: '/proformas/pedidos/stock/by/reserva/articulo'+query
        }).then((response)=>{ 
            //Se recorre la colección para obtener el total
            let totalReserva =0;
            response.data.datos.forEach(element => {
                totalReserva= totalReserva + parseInt(element.Cantidad,10)
            });
            this.setState({
                detallePedidosReserva:response.data.datos,
                isModalDetalleVisible:true,
                totalReserva,
                currentStock: art.currentStock
            }, ()=>  this.setStateToLocalStorage(this.state))
            this.props.cambiar_VisualizacionLoading(false)
        }).catch((err)=>{
        this.props.cambiar_VisualizacionLoading(false)
        })
    }
    generarConsultaDetalleArticuloPedidoInalambrikItera(){
        let filaSeleccionada = this.gridDetProformaApi.getSelectedRows();
        if (filaSeleccionada[0]===undefined){
            alert('Debe seleccionar una fila para poder ver su detalle.')
            return;
        }
        this.props.cambiar_VisualizacionLoading(true);
        let query = "?articulo="+filaSeleccionada[0].Articulo
        global_axios({
        method: 'GET',
        url: '/pedidosmoviles/obtener/por/pedido/itera/inalambrik'+query
        }).then((response)=>{ 
            //Se recorre la colección para obtener el total
            let totalReserva =0;
            response.data.datos.forEach(element => {
                totalReserva= totalReserva + parseInt(element.Cantidad,10)
            });
            let datos = response.data.datos
            datos.forEach((item, i)=>{
                item.NroItem = completar_String((i + 1).toString(), '0', 3);
            })
            this.setState({
                detallePedidosReserva:datos,
                isModalDetalleVisible:true,
                totalReserva,
                currentStock:response.data.stockFisico,
                transitoCantidad: response.data.stockTransito,
                stockDisponibleModal:filaSeleccionada[0].StockDisponible
            }, ()=>  this.setStateToLocalStorage(this.state))
            this.props.cambiar_VisualizacionLoading(false)
        }).catch((err)=>{
        this.props.cambiar_VisualizacionLoading(false)
        })
    }
    generarConsultaUltimosVendidos(){
        if (this.state.cliente_sel===undefined || this.state.cliente_sel === null || this.state.cliente_sel === ''){
            alert('Debe seleccionar un cliente para continuar.')
            return;
        }
        if (this.state.articulo_sel===undefined || this.state.articulo_sel === null || this.state.articulo_sel === ''){
            alert('Debe seleccionar un articulo para continuar.')
            return;
        }
        
        
        this.props.cambiar_VisualizacionLoading(true);
        let query = `?articulo=${this.state.articulo_sel}&cliente=${this.state.cliente_sel.value}`
        global_axios({
        method: 'GET',
        url: '/pedidosmoviles/obtener/articulo/ultimos/vendido'+query
        }).then((response)=>{     
            this.setState({
                ultimosVendidos:response.data.datos,
                isModalDetalleUltimosVendidosVisible:true,
            }, ()=>  this.setStateToLocalStorage(this.state))
            this.props.cambiar_VisualizacionLoading(false)
        }).catch((err)=>{
            this.props.cambiar_VisualizacionLoading(false)
        })
    }
    generarConsultaDetalleTotalVencido(){
        if (this.state.cliente_sel===undefined || this.state.cliente_sel === null || this.state.cliente_sel === ''){
            alert('Debe seleccionar un cliente para continuar.')
            return;
        }
      
        this.setState({
            isModalDetalleTotalVencidoVisible:true,
        }, ()=>  this.setStateToLocalStorage(this.state))
      
    }
    generarConsultaDetalleChequePendiente(){
        if (this.state.cliente_sel===undefined || this.state.cliente_sel === null || this.state.cliente_sel === ''){
            alert('Debe seleccionar un cliente para continuar.')
            return;
        }
        this.setState({
            isModalDetalleChequePendienteVisible:true,
        }, ()=>  this.setStateToLocalStorage(this.state))
      
    }
    handleInputChange(event){
        const target = event.target;
        const name = target.name;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        if(name==='cantidad_ingresada'){
            const patron = /^\d*$/; //Expresión regular para aceptar solo números enteros
            if (patron.test(value) === false) {            
                alert("El número es incorrecto");
                return
            }
        }
        if(name!=='pedidoId'){
            this.setState({
                [name]: value
            },()=>this.setStateToLocalStorage(this.state));
        }else{
            this.setState({
                [name]: value
            })
        }
        
    }
    immutablePush(array, newItem){
        let data = [ ...array, newItem ]
        
        return data;
    }
    immutableDelete(arr, index){
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }
   
    onGridDetProformaReady(params){
        this.gridDetProformaApi = params.api;
        this.gridDetProformaColumnApi = params.columnApi;
    }   
    onGridDetalleProformaReservaArticuloReady (params){
        this.gridDetProformaReservaArticuloApi = params.api;
        this.gridDetProformaReservaArticuloColumnApi = params.columnApi;
    } 
    onGridDetalleSustitutoReady (params){
        this.gridDetSustitutoApi = params.api;
        this.gridDetSustitutoColumnApi = params.columnApi;
    } 
    onGridDetalleTotalVencidoReady (params){
        this.gridDetTotalVencidoApi = params.api;
        this.gridDetTotalVencidoColumnApi = params.columnApi;
    }    
    onGridDetalleChequePendienteReady (params){
        this.gridDetChequePendienteApi = params.api;
        this.gridDetChequePendienteColumnApi = params.columnApi;
    } 
    onGridDetalleUltimosVendidosReady(params){
        this.gridDetUltimosVendidosApi = params.api;
        this.gridDetUltimosVendidosColumnApi = params.columnApi;
    }   
    seleccionarArticulo(value){
        
        if(this.state.cliente_sel!== null && this.state.cliente_sel!==undefined && this.state.cliente_sel!=='' && this.state.cantidad_ingresada>=0){
            const artImages=[]
            if(value){
                if(value.value!== null && value.value!==undefined){
                    artImages.push({url:`/img/articulos/${value.value}_1.jpg`, name: `${value.value} 1`})
                    artImages.push({url:`/img/articulos/${value.value}_2.jpg`, name: `${value.value} 2`})
                    artImages.push({url:`/img/articulos/${value.value}_3.jpg`, name: `${value.value} 3`})
                    artImages.push({url:`/img/articulos/${value.value}_4.jpg`, name: `${value.value} 4`})
                }   
            }
       
            this.setState({ artImages:artImages ,articulo_data:value === [] ? null :value,articulo_sel: value!==null?value.value:null,  observacion:value!==null?value.Observacion:'', referencia:value!==null?value.Referencia:'' }, ()=>  this.setStateToLocalStorage(this.state))
            if(value!==null){
                //Se procede a cargar los articulos sustitutos
                global_axios({
                method: 'GET',
                url: `/articulos/sustitutos/by/id/articulo?articulo_id=${value.value}`
                }).then((response)=>{ 
                    let query = `?articuloId=${value.value}&listaPrecioId=${this.state.listaPrecioCliente}`;   
                    global_axios({
                        method: 'GET',
                        url: `/articulos/by/id/lp${query}`
                        })
                        .then((data)=>{
                            if(data.data.length>0){
                                const artInfo = data.data[0]
                                const precioDescuento = artInfo!=null ?parseFloat(parseFloat(artInfo.Precio)-parseFloat(multiplicarDecimales(artInfo.Precio, value.Descuento/100))):0;
                                this.setState({
                                    articulosSustitutos:response.data.articulos,
                                    articuloPrecioDescuentoLinea:precioDescuento,
                                    articuloMarca:artInfo!=null? artInfo.Marca:'',
                                    articuloSearch:''
                                    
                                },()=>this.setStateToLocalStorage(this.state))
                            }else{
                                this.setState({
                                    articuloPrecioDescuentoLinea:0,
                                    articuloMarca:'',
                                    articuloSearch:''
                                    
                                },()=>this.setStateToLocalStorage(this.state))
                            }
                            
            
                        })
                        
                        .catch((error)=> {
                            alert(error.response?error.response.data.msg:error.message);
                        });
                  
                }).catch((err)=>{
                    this.props.cambiar_VisualizacionLoading(false)
                })
            }else{
                this.setState({
                    articulosSustitutos:[],
                    articuloPrecioDescuentoLinea:0,
                    articuloMarca:'',
                }, ()=>  this.setStateToLocalStorage(this.state))
            }
            

        }else{
            alert('Debe seleccionar un cliente para continuar...')
        }
    }
    addArticulo(){
        //Se comprueba que tenga seleccionado un articulo 
        if(this.state.articulo_sel===null || this.state.articulo_sel === undefined || this.state.articulo_sel === ''){
            alert('Debe seleccionar un artículo para continuar.')
            return
        }
        if(this.state.formaPago_sel===null || this.state.formaPago_sel === undefined || this.state.formaPago_sel === ''){
            alert('Debe seleccionar una  forma de pago para continuar.')
            return
        }
        if(this.state.terminoPago_sel===null || this.state.terminoPago_sel === undefined || this.state.terminoPago_sel === ''){
            alert('Debe seleccionar un  termino de pago para continuar.')
            return
        }
        if(this.state.cantidad_ingresada>=0){
            //Se procede a buscar el artículo para comprobar si fue ingresado anteriormente.
            let encontrado=false;
            for(let i=0; i<this.state.detalleProforma.length;i++){
                let articulo= this.state.detalleProforma[i];
                if(articulo.Articulo===this.state.articulo_sel){
                    encontrado=true;
                }
            }
            if(!encontrado){
                this.buscarStockArticulos();
            }else{
                alert('El artículo ya se encuentra ingresado.')
            }
            
        }else{
            alert('Ingrese una cantidad valida')
        }
    }
    buscarStockArticulos(){
       
        this.props.cambiar_VisualizacionLoading(true)
        const articulo = this.state.articulo_sel;
        
        if (articulo === undefined || articulo === null){
            return;
        }
        //Uso de moment
        const fecha= moment().format('DD/MM/YYYY')
        const mes = fecha.substr(3, 2);
        const periodo = fecha.substr(6, 4);
        if(mes && periodo && articulo){
            global_axios({
            method: 'GET',
            url: `/articulos/${articulo}/${this.state.listaPrecioCliente}`,
            })
            .then((response)=> {
            let articulo_sel = response.data;
                global_axios({
                method: 'GET',
                url: '/stocks/stock/pedidoMovil/'  + periodo + '/' + mes + '/articulos/' + articulo
                })
                .then((response) => {           
                    this.props.cambiar_VisualizacionLoading(false) 
                    let art = response.data;
                    
                    articulo_sel.stockDisponible = art.stock;
                    let vendido = parseInt(this.state.cantidad_ingresada,10) > parseInt(articulo_sel.stockDisponible,10)? parseInt(articulo_sel.stockDisponible,10) : parseInt(this.state.cantidad_ingresada,10) ;
                    
                    //Se procede a crear el objeto que sera insertado en el grid 
                    let articulo= {};
                    articulo.NroItem= completar_String((this.state.detalleProforma.length+ 1).toString(), '0', 3);
                    articulo.Articulo= articulo_sel.codigo;
                    articulo.Descripcion = articulo_sel.descripcion;
                    articulo.StockDisponible = parseInt(articulo_sel.stockDisponible,10) < 0  ? 0 : parseInt(articulo_sel.stockDisponible,10);
                    articulo.CantPorDespachar = parseInt(this.state.cantidad_ingresada,10);
                    articulo.Vendido = vendido<0 ? 0 : vendido
                    articulo.PrecioUnit= parseFloat(Number.isNaN(articulo_sel.preciomayorista)? 0: articulo_sel.preciomayorista);
                    articulo.Descuento = parseFloat(Number.isNaN(articulo_sel.descuento)? 0: articulo_sel.descuento);
                    articulo.GravaIva= art.GravaIva;
                    articulo.Marca = art.Marca
                    articulo.currentStock = parseInt(art.currentStock ,10) < 0  ? 0 : parseInt(art.currentStock ,10); 
                    articulo.referencia = articulo_sel.referencia
                    articulo.observacion = articulo_sel.caracteristica
                    
                    this.setState({ 
                        detalleProforma: this.immutablePush(this.state.detalleProforma, articulo), articulo_sel:null, cantidad_ingresada:0 , articulo_data:null, referencia:'',
                        observacion:'',articuloPrecioDescuentoLinea:0, articuloMarca:'',
                    }, ()=> {this.gridDetProformaApi.ensureIndexVisible(this.state.detalleProforma.length-1); this.setStateToLocalStorage(this.state) });
                    
                    
                })  
                .catch((error)=>{
                    this.props.cambiar_VisualizacionLoading(false)
                            
                    alert(error.response?error.response.data.msg:error.message);
                    
                });
            })
            .catch((error)=> {
            this.props.cambiar_VisualizacionLoading(false)
            if (error.response){
                alert(error.response.data.msg);         
            }else{
                alert(error.message);
            }
            });  
        }

       
    }
    calculoTotales(){
        

        let subtotalConIva = parseFloat(0);
        let subtotalSinIva = parseFloat(0);
        let porcentajeIva = parseFloat(this.state.porcentIva);
        let porcentajeDscto = parseFloat(this.state.porcentajeDscto);
        let valorIva = parseFloat(0);
        let total = parseFloat(0);
        let valorDsctoTotal = parseFloat(0);
        let valorSubTotal = parseFloat(0);
        let valorFlete = parseFloat(0);
        let valorDsctoPlazo= parseFloat(0);
        let porcentajedescuentoplazo =parseFloat(0);
        let PreUnitDesPlazo =parseFloat(0);
        let PreUnitDesPlazoDescontado =parseFloat(0);
        let totalDsctoPlazo=parseFloat(0);
        let valorDsctoLinea=parseFloat(0);
    
        if (this.state.detalleProforma.length>0){
          this.state.detalleProforma.forEach((item) => {
            let cantidad = parseFloat(Number.isNaN(item.Vendido)? 0: item.Vendido);
            let precioUnit = parseFloat(Number.isNaN(item.PrecioUnit)? 0: item.PrecioUnit);
            let porcDescuento = parseFloat(Number.isNaN(item.Descuento)?0: item.Descuento);
            porcentajedescuentoplazo= parseFloat(this.state.porcentajeDsctoPlazo).toFixed(2);

            console.log("PRECIOUNIT",precioUnit)
            console.log("porcentajedescuentoplazo", porcentajedescuentoplazo)
            PreUnitDesPlazo=parseFloat(multiplicarDecimales(precioUnit, parseFloat(porcentajedescuentoplazo)/100));//Rtoala 2020-02-18
            console.log("PreUnitDesPlazo",PreUnitDesPlazo)
            PreUnitDesPlazoDescontado= parseFloat(parseFloat(precioUnit)-parseFloat(PreUnitDesPlazo));//DSCTO PLAZO 20200623 WILLY
            console.log("PreUnitDesPlazoDescontado",PreUnitDesPlazoDescontado)
            valorDsctoPlazo= parseFloat(multiplicarDecimales(cantidad, parseFloat(PreUnitDesPlazo))).toFixed(2);
            console.log("valorDsctoPlazo",valorDsctoPlazo)
            
            totalDsctoPlazo = parseFloat(parseFloat(totalDsctoPlazo) + parseFloat(valorDsctoPlazo)).toFixed(2);

            let precioUnitDscto = parseFloat(multiplicarDecimales(PreUnitDesPlazoDescontado, porcDescuento/100));//WILLY 2020-02-18
            console.log(precioUnitDscto, "precioUnitDscto")
            let precioUnitDescontado = parseFloat(parseFloat(PreUnitDesPlazoDescontado)-parseFloat(precioUnitDscto));
            console.log(precioUnitDescontado, "precioUnitDescontado")
            let subTotalItem = parseFloat(multiplicarDecimales(cantidad, precioUnitDescontado)).toFixed(2);
            console.log(subTotalItem, "subTotalItem")
            let subTotalDsctoItem = parseFloat(multiplicarDecimales(cantidad, precioUnitDscto)).toFixed(2);         
            console.log(subTotalDsctoItem, "subTotalDsctoItem")
            valorSubTotal = parseFloat(parseFloat(valorSubTotal) + parseFloat(subTotalDsctoItem)).toFixed(2);// ES VALOR DESCUENTO LINEA EN EL FORM DE PROFORMA
            console.log(valorSubTotal, "valorSubTotal")
            valorDsctoLinea = parseFloat(parseFloat(valorDsctoLinea) + parseFloat(subTotalDsctoItem)).toFixed(2);
            console.log(valorDsctoLinea, "valorDsctoLinea")

            if (item.GravaIva){
                subtotalConIva = parseFloat(parseFloat(subtotalConIva) + parseFloat(subTotalItem)).toFixed(2);
              }else{
                subtotalSinIva = parseFloat(parseFloat(subtotalSinIva) + parseFloat(subTotalItem)).toFixed(2);          
              }
      
              valorFlete += parseFloat(item.Sublinea==='SX'?subTotalItem:0);
          });
    
          if (parseFloat(porcentajeDscto)>0){
            valorDsctoTotal = parseFloat(multiplicarDecimales(parseFloat(subtotalConIva) + parseFloat(subtotalSinIva) - parseFloat(valorFlete), porcentajeDscto/100)).toFixed(2);
          }
    
          if (parseFloat(subtotalConIva) > parseFloat(valorDsctoTotal)){
            subtotalConIva = parseFloat(parseFloat(subtotalConIva)-parseFloat(valorDsctoTotal)).toFixed(2);
          }else{
            subtotalSinIva = parseFloat(parseFloat(subtotalSinIva)-parseFloat(valorDsctoTotal)).toFixed(2);
          }
    
          valorIva = parseFloat(multiplicarDecimales(subtotalConIva, porcentajeIva/100)).toFixed(2);
          total = parseFloat(parseFloat(subtotalSinIva) + parseFloat(subtotalConIva) + parseFloat(valorIva)).toFixed(2);
          console.log(total, "total")
        }
        

         this.setState( {  valorSubTotal: parseFloat(valorSubTotal), subtotalConIva: parseFloat(subtotalConIva), subtotalSinIva: parseFloat(subtotalSinIva), total: parseFloat(total),
                      totalDscto: parseFloat(valorDsctoTotal), totalDsctoLinea: parseFloat(valorDsctoLinea), valorIva: parseFloat(valorIva), totalDsctoPlazo:totalDsctoPlazo }, ()=>  this.setStateToLocalStorage(this.state) );
      }
    generarDireccionesCliente(cliente, codDireccionSeleccionada=0){
        let direccionesCliente = [{value: 0, label: cliente.direccion_principal}];
        
        if (cliente.detalle_direcciones!==undefined && cliente.detalle_direcciones!==null){
            cliente.detalle_direcciones.forEach((direccionAlt)=>{
            direccionesCliente.push({value: direccionAlt.secuencia , label: direccionAlt.direccion});
            });
        }
        this.setState({ direccionesCliente, direccion_sel: codDireccionSeleccionada}, ()=>  this.setStateToLocalStorage(this.state));    
    }
    getClientebyId(statusForm){
        if (this.state.cliente_sel!==undefined && this.state.cliente_sel!==null){
            const fecha= moment().format('YYYY-MM-DD')
            let codCliente = this.state.cliente_sel.value;
            global_axios({
            method: 'GET',
            url: `/clientes/${codCliente}?actualDate=${fecha}`
            })
            .then((response)=> {
                let cliente = response.data;
                
                let emailValido = esEmailValido(cliente.email_representante);
                if (emailValido===false){
                    alert('El cliente seleccionado: ' + codCliente + ' no tiene un email registrado. Favor ingrese un email en la caja de texto correspondiente.');
                }
                let dirCod = 0
                if(this.state.secuencialDireccion != null){
                    dirCod = this.state.secuencialDireccion
                }
                this.setState({listaPrecioCliente:cliente.ListaPrecio, tipoCliente_sel: cliente.tipo, cupo:cliente.cupo, cupoDisponible: cliente.cupoDisponible, totalVencido:cliente.totalVencido, detalleTotalVencido:cliente.detalleTotalVencido, totalChqPendiente: cliente.totalChqPendiente, detalleChqPendiente: cliente.detalleChqPendiente, email:cliente.email_representante, secuencialDireccion:null, formaPago_sel:statusForm==='N'? cliente.forma_pago: this.state.formaPago_sel}, ()=>  this.setStateToLocalStorage(this.state));
                
                this.generarDireccionesCliente(cliente, dirCod);

            })
            .catch((error)=> {
                alert(error.response?error.response.data.msg:error.message);
            });
        }
    }
    getOptions_Clientes(input, callback){
        if (input.toString().length >= 3 ){
          let query = `?tipo=catalogo&cadena_busq=${input}&status=A&vendedor=${localStorage.usuario}`;     
          cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }
    getOptions_Articulos(input, callback){
        if (input.toString().length >= 2 ){
          let query = `?cadena_busq=${input}&modelo=${this.state.articuloSearch}`;     
          return global_axios({
            method: 'GET',
            url: `/articulos/filter/stock/fecha/compra${query}`
            })
            .then(data => callback(null, {
                options: data.data.map(item => ({
                    value: item.Articulo.toString().toUpperCase(),
                    label: `${item.Nombre.toString().toUpperCase()} (${item.Articulo.toString().toUpperCase()}) (${item.Observacion.toString().toUpperCase()}) (${item.Referencia.toString()})`,
                     Precio:item.Precio, Descuento:item.Descuento, Marca:item.Marca, Referencia:item.Referencia, Observacion:item.Observacion })),
                complete: true        
            }))
            .catch((error)=> {
                alert(error.response?error.response.data.msg:error.message);
            });
          
        }
    }    
    setStateToLocalStorage(state){
        const stateCopy = Object.assign({}, state);
        delete stateCopy.colDetalleTotalVencido
        delete stateCopy.colDetalleChequePendiente
        delete stateCopy.colDetallePedidosReserva
        delete stateCopy.colDetalleSustitutos
        delete stateCopy.colDetalleUltimosVendidos
        delete stateCopy.colsDefDetProforma
        localStorage.setItem('pedidoMovilItera', JSON.stringify(stateCopy))
    }

    componentDidMount(){
        Promise.all([
            this.getFormasDePago(),
            this.getTerminosDePago(),
            obtenerParametros('IVAACTUAL'),
            obtenerParametros('PORCDESCUENTO'),
            this.getSecuencialPedidoMovilItera(),        
            this.getControlCupoStatus(),    
            this.props.generar_LogAuditoriaIngresoForm('1102')
            
         ])
        .then(([result_formaPago,terminosPago,paramIvaActual,paramPorcDscto,ultimoPedido, controlCupo]) => {
            let fechaProceso = getFechaProcesoPorModulo('11');
            let fecha_proceso_moment= moment(fechaProceso, "DD/MM/YYYY").format("DD/MM/YYYY");
            this.setState({
                formaPago: result_formaPago,
                terminosPago,
                porcentIva: parseFloat(paramIvaActual[0].IvaActual),
                porcentajeDscto: parseFloat(paramPorcDscto[0].PorcDescuento),
                ultimoPedido: completar_String((ultimoPedido.codigo - 1).toString(), '0', 6),
                controlCupoStatus:controlCupo.ControlCupo.trim() ==='S' ? 'SI':'NO',
                fechaProcesoString: fecha_proceso_moment,
            },()=>{
                let stateBefore = JSON.parse(localStorage.getItem("pedidoMovilItera"))
                if(JSON.parse(localStorage.getItem("pedidoMovilItera")) != null){
                    this.setState(stateBefore)
                }
            })
            
           
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('1102');
    }
    handleDeleteArticulo(){

        // if (this.state.operacion==='G' || (this.state.operacion==='M' && this.state.esModificable===true) || (this.state.modifProformaTransito===true)){
          let filasSeleccionadas = this.gridDetProformaApi.getSelectedRows();
          
          if (this.state.detalleProforma.length===0){
            alert('No existen artículos en el pedido.');
            return;
          }
    
          if (filasSeleccionadas[0]===undefined){
            alert('Debe seleccionar el artículo que desee eliminar.')
            return;
          }
    
          let itemProforma = filasSeleccionadas[0];
    
        //   if ((!itemProforma.EsEditable) && itemProforma.EsPromocion!=='*'){
        //    this.gridDetProformaApi.stopEditing(true);
        //     alert('La eliminación de este artículo no está permitida.');
        //     return;
        //   }
    
          let eliminar = window.confirm(`¿Está seguro de eliminar el artículo: ${itemProforma.Articulo.trim()}?`);
            if (eliminar){
              
              this.quitarArticuloDeProforma(itemProforma)  
              
            }
        // }else{
        //   alert('La modificación de esta proforma no está permitida.');
        // }
    }
    quitarArticuloDeProforma(itemProf){
        let indiceEliminar;
        for(indiceEliminar=0; indiceEliminar<this.state.detalleProforma.length; indiceEliminar++){
            if (this.state.detalleProforma[indiceEliminar].NroItem === itemProf.NroItem){
                break;
            }
        }
        this.setState({ detalleProforma: this.deleteItemArray(this.state.detalleProforma, indiceEliminar) }, ()=>  this.setStateToLocalStorage(this.state));
    }
    deleteItemArray (arr, index) {
        let indice = formatearNumeroEntero(index);
        let arr_tmp = arr.slice(0, indice).concat(arr.slice(indice+1));
        arr_tmp.forEach((item, i)=>{
          item.NroItem = completar_String((i + 1).toString(), '0', 3);
        });
        return arr_tmp;
    }
    getSecuencialPedidoMovilItera(){
        return global_axios({
            method: 'GET',
            url: `/parametros/cargar_parametro/itera/by/name/PedidoMovilIteraSecuencia`
            })
            .then((response)=> {
                let parametro = response.data;
                return parametro
            })
            .catch((error)=> {
                alert(error.response?error.response.data.msg:error.message);
            });
    }
    getControlCupoStatus(){
        return global_axios({
            method: 'GET',
            url: `/parametros/cargar_parametro/itera/control/cupo`
            })
            .then((response)=> {
                let parametro = response.data;
                return parametro
            })
            .catch((error)=> {
                alert(error.response?error.response.data.msg:error.message);
            });
    }
    getFormasDePago(){
        return global_axios({
                method: 'GET',
                url: `/formasPago`
                })
                .then((response)=> {
                    let formasPagos = response.data;
                    formasPagos.forEach(element => {
                        element.label = element.Descripcion
                        element.value = element.FormaPagoId
                    });
                    return formasPagos
                })
                .catch((error)=> {
                    alert(error.response?error.response.data.msg:error.message);
                });
    }   
    changeCliente(value){
        if(Array.isArray(value)){
            value=null;
        } 
        this.setState({cliente_sel: value, tipoCliente_sel: null, vendedor_sel: null, direccion_sel: null},()=> {
            this.setStateToLocalStorage(this.state)
            this.getClientebyId(this.state.statusForm)
        })   
    }
    getTerminosDePago(){
        
        return global_axios({
                method: 'GET',
                url: `/terminosPago`
                })
                .then((response)=> {
                let terminosPagos = response.data;
                terminosPagos.forEach(element => {
                    element.label = `${element.Descripcion}, ${element.Descuento}%`
                    element.value = element.TerminoPagoId
                    element.descuento = element.Descuento
                });
                return terminosPagos
            })
            .catch((error)=> {
                alert(error.response?error.response.data.msg:error.message);
            });
    }
    getPedidoById(){
        let idPedido = this.state.pedidoId;
        if (validarCampoString(idPedido, 6)){      
        this.props.cambiar_VisualizacionLoading(true);
        global_axios({
            method: 'GET',
            url: '/pedidosmoviles/obtener/por/id/' + idPedido,
        })
        .then((response)=> {
            let data_pedido = response.data;
            let emailValido = esEmailValido(data_pedido.cli.Email);
            if (emailValido===false){
                this.props.cambiar_VisualizacionLoading(false);
                alert('El cliente: ' + data_pedido.Cliente + ' no tiene un email registrado. Favor proceda a ingresar el email en la caja de texto correspondiente.');          
            }
            this.setState({ pedidoSeleccionado: data_pedido }, ()=>  this.setStateToLocalStorage(this.state));
            this.setState({
                cliente_sel: generarItemCatalogoSeleccionado(this.state.pedidoSeleccionado.Cliente, this.state.pedidoSeleccionado.cli.Nombre),
                terminoPago_sel:this.state.pedidoSeleccionado.TerminoPago,
                formaPago_sel: data_pedido.FormaPago,
                observacion:this.state.pedidoSeleccionado.Notas,
                statusForm:'M',
                cupo:this.state.pedidoSeleccionado.cli.Cupo,
                cupoDisponible: this.state.pedidoSeleccionado.cli.cupoDisponible,
                email: data_pedido.cli.Email,
                secuencialDireccion: data_pedido.SecuencialDireccion,
                total: data_pedido.Total,
                totalDsctoPlazo: data_pedido.TotalDsctoPlazo,
                totalVencido: data_pedido.TotalVencido
            }, ()=>{
                this.getClientebyId(this.state.statusForm)
                const terPago =this.state.terminosPago.find(element => element.value === this.state.pedidoSeleccionado.TerminoPago)
            
                const forPago =this.state.formaPago.find(element => element.value === this.state.pedidoSeleccionado.FormaPago)
                this.changeFormaPago(forPago)
                this.changeTerminoPago(terPago)
            });
           

            //this.generarDireccionesCliente(this.state.pedidoSeleccionado.cli);



            let detallePedido = this.state.pedidoSeleccionado.detalle_ped;

            let itemsProforma = [];
            detallePedido.forEach((pedido, indice)=>{
                /* Se genera cada item de la proforma con los datos del pedido*/
                itemsProforma.push({
                    NroItem:completar_String(pedido.Secuencia.toString(), '0', 3),
                    Articulo: pedido.Articulo,
                    Descripcion: pedido.art.nombre,
                    StockDisponible: pedido.StockDisponible,
                    CantPorDespachar: parseInt(pedido.Cantidad,10),
                    Vendido:pedido.Vendido,
                    PrecioUnit: parseFloat(Number.isNaN(pedido.Precio)? 0: pedido.Precio),
                    Descuento: parseFloat(Number.isNaN(pedido.PorcDescuento)? 0: pedido.PorcDescuento),
                    GravaIva:pedido.art.Iva,
                    Marca:pedido.art.Marca,
                    currentStock:pedido.art.currentStock
                });
            });
                
            this.setState({ detalleProforma: itemsProforma}, ()=>  {this.setStateToLocalStorage(this.state)});

            this.props.cambiar_VisualizacionLoading(false);
                
          
        })
        .catch((error)=>{
            this.props.cambiar_VisualizacionLoading(false);
            alert(error.response?error.response.data.msg:error.message);
        });
        }
        else{
        alert('No ha especificado un No. de Pedido válido.');
        }
    }
    limpiar(){
        let mensaje = window.confirm(`¿Esta seguro de limpiar el formulario`);
        if(mensaje){  
            this.setState({
                observacionDescription: '',
                fechaProcesoString:'',
                articuloSearch:'',
                isModalFotosVisible:false,
                currentImageIndex:0,
                artImages:[],
                modificaPedido:false,
                stockDisponibleModal:0,
                articulo_data:null,
                referencia:'',
                articuloPrecioDescuentoLinea:0,
                articuloMarca:'',
                articuloName:'',
                articulosSustitutos:[],
                paginationSustituto:{
                    totalFilas: 0,
                    totalFilasPorPagina: 0,
                    primaraFilaPagina: 0,
                    ultimaFilaPagina: 0,
                },
                secuencialDireccion:null,
                email:'',
                transitoCantidad:0,
                detalleChqPendiente:[],
                totalChqPendiente:0,
                ultimosVendidos:[],
                isModalDetalleUltimosVendidosVisible:false,
                totalDsctoLinea: parseFloat(0.00),   
                porcentajeDsctoPlazo:0,
                totalDsctoPlazo:0,
                listaPrecioCliente:'',
                formaPago:[],
                statusForm:'N',
                pedidoSeleccionado:'',
                pedidoId:'',
                ultimoPedido:'',
                observacion:'',
                valorSubTotal:parseFloat(0.00),
                subtotalConIva: parseFloat(0.00),
                subtotalSinIva: parseFloat(0.00),
                total: parseFloat(0.00),
                valorIva: parseFloat(0.00),
                totalDscto: parseFloat(0.00),      
                totalReserva:parseFloat(0.00),
                isModalDetalleVisible:false,
                isModalDetalleTotalVencidoVisible:false,
                isModalDetalleChequePendienteVisible:false,
                detallePedidosReserva:[],
                porcentIva: parseFloat(0.00),
                porcentajeDscto: parseFloat(0.00),
                cantidad_ingresada:0,
                cliente_sel:null,
                tipoCliente_sel: null, 
                vendedor_sel: null, 
                direccion_sel: null, 
                articulo_sel:null,
                terminoPago_sel: null,
                formaPago_sel: null,
                detalleProforma: [],
                terminosPago: [],
                cupo:0,
                cupoDisponible:0,//ES EL RIESGO CLIENTE
                totalVencido:0,
                detalleTotalVencido:[],
                pagination: {
                    totalFilas: 0,
                    totalFilasPorPagina: 0,
                    primaraFilaPagina: 0,
                    ultimaFilaPagina: 0,
                },
                paginationDetTotalVencido: {
                    totalFilas: 0,
                    totalFilasPorPagina: 0,
                    primaraFilaPagina: 0,
                    ultimaFilaPagina: 0,
                },
                paginationDetChequePendiente:{
                    totalFilas: 0,
                    totalFilasPorPagina: 0,
                    primaraFilaPagina: 0,
                    ultimaFilaPagina: 0,
                },
                paginationUltimosVendidos: {
                    totalFilas: 0,
                    totalFilasPorPagina: 0,
                    primaraFilaPagina: 0,
                    ultimaFilaPagina: 0,
                },
            }, ()=>  localStorage.removeItem('pedidoMovilItera'))
            localStorage.removeItem('pedidoMovilItera')
            let fechaProceso = getFechaProcesoPorModulo('11');
            let fecha_proceso_moment= moment(fechaProceso, "DD/MM/YYYY").format("DD/MM/YYYY");
            Promise.all([
                this.getFormasDePago(),
                this.getTerminosDePago(),
                obtenerParametros('IVAACTUAL'),
                obtenerParametros('PORCDESCUENTO'),
                this.getSecuencialPedidoMovilItera(),
                this.getControlCupoStatus(), 
                
             ])
            .then(([result_formaPago,terminosPago,paramIvaActual,paramPorcDscto,ultimoPedido,controlCupo]) => {
                this.setState({
                    fechaProcesoString: fecha_proceso_moment,
                    formaPago: result_formaPago,
                    terminosPago,
                    porcentIva: parseFloat(paramIvaActual[0].IvaActual),
                    porcentajeDscto: parseFloat(paramPorcDscto[0].PorcDescuento),
                    ultimoPedido: completar_String((ultimoPedido.codigo - 1).toString(), '0', 6),
                    controlCupoStatus:controlCupo.ControlCupo ==='S' ? 'SI':'NO'
                })
                localStorage.removeItem("pedidoMovilItera")
            });
        }
        
    }
    limpiar2(){
        
        this.setState({
            observacionDescription:'',
            fechaProcesoString:'',
            articuloSearch:'',
            isModalFotosVisible:false,
            currentImageIndex:0,
            artImages:[],
            stockDisponibleModal:0,
            articulo_data:null,
            referencia:'',
            observacion:'',
            articuloPrecioDescuentoLinea:0,
            articuloMarca:'',
            articuloName:'',
            articulosSustitutos:[],
            paginationSustituto:{
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
            secuencialDireccion:null,
            email:'',
            transitoCantidad:0,
            detalleChqPendiente:[],
            totalChqPendiente:0,
            ultimosVendidos:[],
            isModalDetalleUltimosVendidosVisible:false,
            totalDsctoLinea: parseFloat(0.00),   
            porcentajeDsctoPlazo:0,
            totalDsctoPlazo:0,
            listaPrecioCliente:'',
            formaPago:[],
            statusForm:'N',
            pedidoSeleccionado:'',
            pedidoId:'',
            ultimoPedido:'',
            valorSubTotal:parseFloat(0.00),
            subtotalConIva: parseFloat(0.00),
            subtotalSinIva: parseFloat(0.00),
            total: parseFloat(0.00),
            valorIva: parseFloat(0.00),
            totalDscto: parseFloat(0.00),      
            totalReserva:parseFloat(0.00),
            isModalDetalleVisible:false,
            isModalDetalleTotalVencidoVisible:false,
            isModalDetalleChequePendienteVisible:false,
            detallePedidosReserva:[],
            porcentIva: parseFloat(0.00),
            porcentajeDscto: parseFloat(0.00),
            cantidad_ingresada:0,
            cliente_sel:null,
            tipoCliente_sel: null, 
            vendedor_sel: null, 
            direccion_sel: null, 
            articulo_sel:null,
            terminoPago_sel: null,
            formaPago_sel: null,
            detalleProforma: [],
            terminosPago: [],
            cupo:0,
            cupoDisponible:0,//ES EL RIESGO CLIENTE
            totalVencido:0,
            detalleTotalVencido:[],
            pagination: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
            paginationDetTotalVencido: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
            paginationDetChequePendiente:{
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
            paginationUltimosVendidos: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
        }, ()=> localStorage.removeItem("pedidoMovilItera"))
        let fechaProceso = getFechaProcesoPorModulo('11');
        let fecha_proceso_moment= moment(fechaProceso, "DD/MM/YYYY").format("DD/MM/YYYY");
        Promise.all([
            this.getFormasDePago(),
            this.getTerminosDePago(),
            obtenerParametros('IVAACTUAL'),
            obtenerParametros('PORCDESCUENTO'),
            this.getSecuencialPedidoMovilItera(),
            this.getControlCupoStatus(), 
            
            ])
        .then(([result_formaPago,terminosPago,paramIvaActual,paramPorcDscto,ultimoPedido,controlCupo]) => {
            this.setState({
                fechaProcesoString: fecha_proceso_moment,
                formaPago: result_formaPago,
                terminosPago,
                porcentIva: parseFloat(paramIvaActual[0].IvaActual),
                porcentajeDscto: parseFloat(paramPorcDscto[0].PorcDescuento),
                ultimoPedido: completar_String((ultimoPedido.codigo - 1).toString(), '0', 6),
                controlCupoStatus:controlCupo.ControlCupo ==='S' ? 'SI':'NO'
            })
            localStorage.removeItem("pedidoMovilItera")
        });
        
        
    }
    nextImage(){
        if(this.state.artImages.length -1  === this.state.currentImageIndex){
            this.setState({
                currentImageIndex:0
            })
        }else{
            this.setState({
                currentImageIndex: this.state.currentImageIndex + 1
            })
        }
    }
    previousImage(){
        if(0 === this.state.currentImageIndex){
            this.setState({
                currentImageIndex:this.state.artImages.length -1
            })
        }else{
            this.setState({
                currentImageIndex: this.state.currentImageIndex - 1
            })
        }
    }
    
    render(){
        return (
            <ContenedorForm porc_ancho={92}>
            <HeaderForm>
                <ContainerAlineado>
                    <TituloForm>Pedido Móvil Itera</TituloForm>
                    <LabelCabecera>Controla cupo: {this.state.controlCupoStatus===undefined?'':this.state.controlCupoStatus}</LabelCabecera>
                    <LabelCabecera>Fecha Proceso: {this.state.fechaProcesoString===undefined?'':this.state.fechaProcesoString}</LabelCabecera>
                    <LabelCabecera>Últ. Pedido: {this.state.ultimoPedido===undefined?'':this.state.ultimoPedido}</LabelCabecera>

                    
                </ContainerAlineado>
            </HeaderForm>
                <CuerpoForm>

                    <Row>
                        <div className='col-sm-12'>
                            <Tabs>
                                <TabList>
                                    <Tab><h4>Cliente</h4></Tab>
                                    <Tab><h4>Pedido</h4></Tab>
                                    <Tab><h4 style={{backgroundColor: this.state.articulosSustitutos.length > 0 ? 'green' : 'white' }} >Sustitutos</h4></Tab>
                                    <Label style={{display:'flex', justifyContent:'flex-end', fontSize:'14px'}}>
                                        <input type="checkbox" name="modificaPedido" checked={this.state.modificaPedido} onChange={this.changeModificaPedido} />
                                            Modifica Pedido
                                    </Label>
                                </TabList>

                                <TabPanel>
                                    {
                                        this.state.modificaPedido?<ContainerCol className='col-sm-2 col-xs-12'>
                                            <LabelFormCustom>Pedido:</LabelFormCustom>
                                            <InputSearch height={staticHeight} tipoInput='text' nombre='pedidoId' placeholder='Pedido' valor={this.state.pedidoId} func_CambiarValor={this.handleInputChange}
                                            func_BuscarValor={this.getPedidoById} func_OnFocus={()=>{this.limpiar2()}} func_Onblur={()=>{this.completarNumeroComprob()}}/>
                                        </ContainerCol>
                                        :null
                                    }
                                    
                                    <ContainerCol className='col-sm-4 col-xs-12'>
                                        <LabelFormCustom>Cliente:</LabelFormCustom>
                                        <ReactSelectAsync height={staticHeight} value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} 
                                        func_onChange={(value)=>{this.changeCliente(value)}}/>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-2 col-xs-12'>
                                        <LabelFormCustom>Email:</LabelFormCustom>
                                        <InputText height={staticHeight} name='email' value={this.state.email===undefined?'':this.state.email}   onChange={this.handleInputChange} type='text' className='form-control input-sm'  />
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-4 col-xs-12'>
                                        <LabelFormCustom>Dirección de Envío:</LabelFormCustom>
                                        <ReactSelect height={staticHeight} searchable={false} options={ this.state.direccionesCliente } value={this.state.direccion_sel} func_onChange={(value)=>{this.setState({direccion_sel: value===null?null:value.value},()=>this.setStateToLocalStorage(this.state))}}/>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-2 col-xs-12'>
                                        <LabelFormCustom>Forma Pago:</LabelFormCustom>
                                        <ReactSelect  height={staticHeight} options={ this.state.formaPago } value={this.state.formaPago_sel}
                                        func_onChange={(value)=>{ this.changeFormaPago(value)}}/>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-2 col-xs-12'>
                                        <LabelFormCustom>Termino Pago:</LabelFormCustom>
                                        <ReactSelect  height={staticHeight} options={ this.state.terminosPago } value={this.state.terminoPago_sel}
                                        func_onChange={(value)=>{this.changeTerminoPago(value)} }/>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-1 col-xs-6'>
                                        <LabelFormCustom>Cupo:</LabelFormCustom>
                                        <InputText height={staticHeight} disabled={true} autoComplete='off' name='cupo' value={this.state.cupo===undefined?'':parseFloat(this.state.cupo).toFixed(2)} type='number' className='form-control input-sm'  />
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-2 col-xs-6'>
                                        <LabelFormCustom>Cupo Disponible:</LabelFormCustom>
                                        <InputText height={staticHeight} disabled={true} autoComplete='off' name='cupoDisponible' value={this.state.cupoDisponible===undefined?'':parseFloat(this.state.cupoDisponible).toFixed(2)} type='number' className='form-control input-sm' />
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-2 col-xs-6'>
                                        <LabelFormCustom>Total Vencido:</LabelFormCustom>
                                        <InputText height={staticHeight} disabled={true} autoComplete='off' name='totalVencido' value={this.state.totalVencido===undefined?'':parseFloat(this.state.totalVencido).toFixed(2)} type='number' className='form-control input-sm' />
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-3 col-xs-6'>
                                        <LabelFormCustom>Total Cheque Pendiente:</LabelFormCustom>
                                        <InputText height={staticHeight} disabled={true} autoComplete='off' name='totalChqPendiente' value={this.state.totalChqPendiente===undefined?'':parseFloat(this.state.totalChqPendiente).toFixed(2)} type='number' className='form-control input-sm' />
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-3 col-xs-12'>
                                        <LabelFormCustom>Observación:</LabelFormCustom>
                                        <InputText height={staticHeight} name='observacionDescription' value={this.state.observacionDescription} onChange={this.handleInputChange} type="text" className='form-control input-sm'/>
                                    </ContainerCol>  
                                    <ContainerCol className='col-sm-3 col-xs-6'>
                                        <div className='btn-group'>                            
                                            <button type='button' className='btn btn-link btn-xs'  onClick={this.generarConsultaDetalleTotalVencido}><i className="fa fa-info" aria-hidden="true"/> Detalle Total Vencido</button>  
                                        </div>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-3 col-xs-6'>
                                        <div className='btn-group'>                            
                                            <button type='button' className='btn btn-link btn-xs'  onClick={this.generarConsultaDetalleChequePendiente}><i className="fa fa-info" aria-hidden="true"/> Detalle  Cheque Pendientes</button>  
                                        </div>
                                    </ContainerCol>
                                   
                                </TabPanel>
                                <TabPanel>
                                    <ContainerCol className='col-sm-3 col-xs-12'>
                                        <LabelFormCustom>Modelo:</LabelFormCustom>
                                        <InputText   height={staticHeight}  name='articuloSearch' value={this.state.articuloSearch}  type='text' className='form-control input-sm'  onChange={this.handleInputChange}/>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-3 col-xs-12'>
                                        <LabelFormCustom>Artículo:</LabelFormCustom>
                                        {/* <ReactSelect   height={staticHeight} options={ this.state.foundArticulos } value={this.state.articulo_sel || ''}
                                            func_onChange={(value)=>{this.seleccionarArticulo(value)}}/> */}
                                        <ReactSelectAsync height={staticHeight} value={this.state.articulo_data} func_loadOptions={this.getOptions_Articulos}
                                        func_onChange={(value)=>{this.seleccionarArticulo(value)}}/>
                                    </ContainerCol>
                                    {this.state.referencia!==''?  <ContainerCol className='col-sm-2 col-xs-12'>
                                        <strong><p style={{fontSize:'10px'}}>{`${this.state.referencia} ${this.state.observacion}`}</p></strong>
                                    </ContainerCol>:null}
                                   
                                    <ContainerCol className='col-sm-2 col-xs-6'>
                                        <LabelFormCustom>Precio:</LabelFormCustom>
                                        <InputText height={staticHeight} disabled={true} autoComplete='off' name='articuloPrecioDescuentoLinea' value={this.state.articuloPrecioDescuentoLinea} type='text' className='form-control input-sm'  onChange={this.handleInputChange}/>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-2 col-xs-6'>
                                        <LabelFormCustom>Marca:</LabelFormCustom>
                                        <InputText height={staticHeight} disabled={true} autoComplete='off' name='articuloMarca' value={this.state.articuloMarca} type='text' className='form-control input-sm' onChange={this.handleInputChange}/>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-1 col-xs-8'>
                                        <LabelFormCustom>Cantidad:</LabelFormCustom>
                                        <InputText height={staticHeight} autoComplete='off' name='cantidad_ingresada' value={this.state.cantidad_ingresada===undefined?'':this.state.cantidad_ingresada} type='text' className='form-control input-sm' placeholder='Cant.' onChange={this.handleInputChange}/>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-1 col-xs-4'  margen_arriba='15'>
                                        <ContenedorBoton>
                                            <Tooltip placement='right' overlay='Añadir/Quitar un artículo'>
                                                <div className='btn-group pull-left'>
                                                    <button type='button' className='btn btn-success btn-md' onClick={this.addArticulo}><i className='fa fa-plus'></i></button>
                                                    <button type='button' className='btn btn-danger btn-md' onClick={this.handleDeleteArticulo}><i className='fa fa-window-close'></i></button>
                                                </div>
                                            </Tooltip>
                                        </ContenedorBoton>
                                    </ContainerCol>
                                    <Row>
                                        <ContainerCol className='col-sm-3 col-xs-6'>
                                            <div className='btn-group'>                            
                                                <button type='button' className='btn btn-link btn-xs'  onClick={this.generarConsultaDetalleArticuloPedidoInalambrikItera}><i className="fa fa-info" aria-hidden="true"/> Stock en bodega</button>  
                                            </div>
                                        </ContainerCol>
                                        
                                        <ContainerCol className='col-sm-3 col-xs-6'>
                                            <div className='btn-group'>                            
                                                <button type='button' className='btn btn-link btn-xs'  onClick={this.generarConsultaUltimosVendidos}><i className="fa fa-info" aria-hidden="true"/> Ultimas 6 Ventas</button>  
                                            </div>
                                        </ContainerCol>
                                    </Row>
                                    {isSmartPhone&&(this.state.articulo_sel!=='' && this.state.articulo_sel!== null && this.state.articulo_sel!== undefined) ?  <div className="col-sm-3">
                                           
                                        <div className='btn-group'>                            
                                            <button type='button' className='btn btn-link btn-xs'  onClick={this.showImagesModal}><i className="fa fa-info" aria-hidden="true"/>Fotos de artículo</button>  
                                        </div>


                                        </div> : ""}
                                    <Row>
                                        <div className='col-sm-9 col-xs-12'>
                                            <Row>
                                                <div className='col-sm-12 col-xs-12'>
                                                    <AgGridRender  alturaRow={40} altura='200px' data={this.state.detalleProforma} columnas={this.state.colsDefDetProforma}
                                                    gridOptions={this.gridDetProformaOptions} onGridReady={this.onGridDetProformaReady}/>
                                                </div>
                                            </Row>
                                            
                                        </div>
                                        {!isSmartPhone&&(this.state.articulo_sel!=='' && this.state.articulo_sel!== null && this.state.articulo_sel!== undefined) ?
                                        <div className='col-sm-3 col-xs-12'>
                                            <div className='btn-group'>                            
                                                <button type='button' className='btn btn-link btn-xs'  onClick={this.showImagesModal}><i className="fa fa-info" aria-hidden="true"/>Fotos de artículo</button>  
                                            </div>
                                            
                                        </div>
                                          : ""}
                                        
                                    </Row>  
                                    
                                    <Row>
                                        <div className='col-sm-3 col-xs-12'>
                                            <div className='col-sm-2 col-xs-10'>
                                                <LabelTotales>Dscto. Línea:</LabelTotales>
                                            </div>
                                            <div className='col-sm-1 col-xs-2'>
                                                <LabelValorTotales>{formatearNumeroDecimal(this.state.totalDsctoLinea)}</LabelValorTotales>
                                            </div> 
                                        </div>            
                                        {/* <div className='col-sm-2'>
                                            <LabelTotales>{`Dscto. Global(${this.state.porcentajeDscto}%):`}</LabelTotales>
                                        </div>        */}
                                        <div className='col-sm-3 col-xs-12'>
                                            <div className='col-sm-2 col-xs-10'>
                                                <LabelTotales>{`Dscto. Por Plazo(${this.state.porcentajeDsctoPlazo}%):`}</LabelTotales>
                                            </div>
                                            <div className='col-sm-1 col-xs-2'>
                                                <LabelValorTotales>{formatearNumeroDecimal(this.state.totalDsctoPlazo)}</LabelValorTotales>
                                            </div>    
                                        </div>        
                                        <div className='col-sm-3 col-xs-12'>
                                            <div className='col-sm-2 col-xs-10'>
                                                <LabelTotales>{`Base Iva (${this.state.porcentIva}%):`}</LabelTotales>
                                            </div>
                                            <div className='col-sm-1 col-xs-2'>
                                                <LabelValorTotales>{formatearNumeroDecimal(this.state.subtotalConIva)}</LabelValorTotales>
                                            </div>
                                        </div>
                                        <div className='col-sm-3 col-xs-12'>
                                            <div className='col-sm-2 col-xs-10'>
                                                <LabelTotales>Base Sin Iva:</LabelTotales>
                                            </div>
                                            <div className='col-sm-1 col-xs-2'>
                                                <LabelValorTotales>{formatearNumeroDecimal(this.state.subtotalSinIva)}</LabelValorTotales>
                                            </div>
                                        </div>
                                        <div className='col-sm-3 col-xs-12'>

                                        </div>
                                        <div className='col-sm-3 col-xs-12'>
                                            
                                        </div>
                                        <div className='col-sm-3 col-xs-12'>
                                            <div className='col-sm-2 col-xs-10'>
                                                <LabelTotales>Iva: </LabelTotales>
                                            </div>
                                            <div className='col-sm-1 col-xs-2'>
                                                <LabelValorTotales>{formatearNumeroDecimal(this.state.valorIva)}</LabelValorTotales>
                                            </div>  
                                        </div>
                                        <div className='col-sm-3 col-xs-12'>
                                            <div className='col-sm-2 col-xs-10'>
                                                <LabelTotales>Total: </LabelTotales>
                                            </div>
                                            <div className='col-sm-1 col-xs-2'>
                                                <LabelValorTotales>{formatearNumeroDecimal(this.state.total)}</LabelValorTotales>
                                            </div>     
                                        </div>
                                    </Row>
                                </TabPanel>
                                <TabPanel >
                                    <Row>
                                        <ContainerCol className='col-xs-12 col-sm-12'>
                                            <h5>Artículo: {this.state.articuloName}</h5>
                                        </ContainerCol>
                                        <ContainerCol  align="center" className="col-xs-12 col-sm-12">
                                            <Row>
                                                <ContainerCol className="col-xs-12 col-sm-12 " >
                                                    <AgGridRender
                                                        altura='150px'
                                                        data={this.state.articulosSustitutos}
                                                        columnas={this.state.colDetalleSustitutos}
                                                        onGridReady={this.onGridDetalleSustitutoReady}
                                                        gridOptions={this.gridDetSustitutoOptions}
                                                        alturaRow={20}
                                                    />
                                                </ContainerCol>
                                            </Row>
                                            <Row>
                                                <div className="col-xs-12 col-sm-12">
                                                    <Row>
                                                        <ContainerCol className="col-xs-12 col-sm-12">
                                                            <PaginationLabels>
                                                                {this.state.paginationSustituto.primaraFilaPagina} a {this.state.paginationSustituto.ultimaFilaPagina} de {this.state.paginationSustituto.totalFilas}
                                                            </PaginationLabels>
                                                            <PaginationButtons>
                                                                <div className="btn-group btn-group-xs" role="group">
                                                                    <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetSustitutoApi.paginationGoToFirstPage()}>
                                                                        <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                                                    </button>
                                                                    <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetSustitutoApi.paginationGoToPreviousPage()}>
                                                                        <i className="fa fa-angle-left fa-fw"></i>Anterior
                                                                    </button>
                                                                    <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetSustitutoApi.paginationGoToNextPage()}>
                                                                        Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                                                    </button>
                                                                    <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetSustitutoApi.paginationGoToLastPage()}>
                                                                        Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                                                    </button>
                                                                </div>
                                                            </PaginationButtons>
                                                        </ContainerCol>
                                                    </Row>
                                                </div>    
                                            </Row>
                                          
                                        </ContainerCol>
                                    </Row>
                                </TabPanel>
                            </Tabs>
                        </div>
                    </Row>
                   
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>         
                                <Tooltip placement='right' overlay={'Guardar Pedido'}> 
                                    <button type='button' className='btn btn-primary btn-lg' onClick={this.guardarPedido}><i className='fa fa-floppy-o fa-lg'></i></button>
                                </Tooltip>                   
                              <Tooltip placement='right' overlay={'Enviar Pedido'}> 
                                    <button type='button' className='btn btn-success btn-lg' onClick={this.enviarPedido}><i className='fa fa-paper-plane fa-lg'></i></button>
                                </Tooltip>
                                <Tooltip placement='right' overlay={'Limpiar Pedido'}> 
                                    <button type='button' className='btn btn-default btn-lg' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'></i></button>
                                </Tooltip>  
                                <Tooltip placement='right' overlay={'Anular Pedido'}>   
                                    <button type='button' className='btn btn-danger btn-lg' onClick={this.anularPedido}><i className='fa fa-minus-circle fa-lg'></i></button>
                                </Tooltip>
                            </div>
                        </ContainerCol>
                    </Row>
                    
                    <ModalResponsive   closeOut={true} open={this.state.isModalDetalleVisible} onClose={() => this.setState({isModalDetalleVisible:false})}>
                        <ModalContainer>
                            <Row>
                                <ContainerCol className='col-xs-12 col-sm-12' align="center">
                                    <h4><strong>Detalle Reserva</strong></h4>
                                    <Hr />
                                </ContainerCol>
                                <ContainerCol className='col-xs-12 col-sm-12'>
                                    <h5>Artículo: {this.state.articuloName}</h5>
                                </ContainerCol>
                                <ContainerCol className='col-xs-6 col-sm-6'>
                                    <h5>Stock: {this.state.currentStock}</h5>
                                </ContainerCol>
                                <ContainerCol className='col-xs-6 col-sm-6'>
                                    <h5>Transito: {this.state.transitoCantidad}</h5>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol  align="center" className="col-xs-12 col-sm-12">
                                    <Row>
                                        <ContainerCol className="col-xs-12 col-sm-12">
                                            <AgGridRender
                                                altura='150px'
                                                data={this.state.detallePedidosReserva}
                                                columnas={this.state.colDetallePedidosReserva}
                                                onGridReady={this.onGridDetalleProformaReservaArticuloReady}
                                                gridOptions={this.gridDetProformaReservaOptions}
                                                alturaRow={20}
                                            />
                                        </ContainerCol>
                                    </Row>
                                    <Row>
                                        <div className="col-xs-12 col-sm-12">
                                            <Row>
                                                <ContainerCol className="xol-xs-2 col-sm-2 pull-right">
                                                    <LabelTotales>Total: </LabelTotales> <LabelValorTotales>{formatearNumeroEntero(this.state.totalReserva)}</LabelValorTotales>
                                                </ContainerCol>
                                                <ContainerCol className="xol-xs-4 col-sm-4 pull-left">
                                                    <LabelTotales>Stock Disponible: </LabelTotales> <LabelValorTotales>{formatearNumeroEntero(this.state.stockDisponibleModal)}</LabelValorTotales>
                                                </ContainerCol>
                                                <ContainerCol className="col-xs-12 col-sm-12">
                                                    <PaginationLabels>
                                                        {this.state.pagination.primaraFilaPagina} a {this.state.pagination.ultimaFilaPagina} de {this.state.pagination.totalFilas}
                                                    </PaginationLabels>
                                                    <PaginationButtons>
                                                        <div className="btn-group btn-group-xs" role="group">
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetProformaReservaArticuloApi.paginationGoToFirstPage()}>
                                                                <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                                            </button>
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetProformaReservaArticuloApi.paginationGoToPreviousPage()}>
                                                                <i className="fa fa-angle-left fa-fw"></i>Anterior
                                                            </button>
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetProformaReservaArticuloApi.paginationGoToNextPage()}>
                                                                Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                                            </button>
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetProformaReservaArticuloApi.paginationGoToLastPage()}>
                                                                Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                                            </button>
                                                        </div>
                                                    </PaginationButtons>
                                                </ContainerCol>
                                            </Row>
                                        </div>    
                                    </Row>
                                    
                                </ContainerCol>
                            </Row>
                        </ModalContainer>
                    </ModalResponsive>
                    <ModalResponsive   closeOut={true} open={this.state.isModalDetalleTotalVencidoVisible} onClose={() => this.setState({isModalDetalleTotalVencidoVisible:false})}>
                        <ModalContainer>
                            <Row>
                                <ContainerCol className='col-xs-12 col-sm-12' align="center">
                                    <h4><strong>Detalle Total Vencido</strong></h4>
                                    <Hr />
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol  align="center" className="col-xs-12 col-sm-12">
                                    <Row>
                                        <ContainerCol className="col-xs-12 col-sm-12">
                                            <AgGridRender
                                                altura='150px'
                                                data={this.state.detalleTotalVencido}
                                                columnas={this.state.colDetalleTotalVencido}
                                                onGridReady={this.onGridDetalleTotalVencidoReady}
                                                gridOptions={this.gridDetTotalVencidoOptions}
                                                alturaRow={20}
                                            />
                                        </ContainerCol>
                                    </Row>
                                    <Row>
                                        <div className="col-xs-12 col-sm-12">
                                            <Row>
                                                <ContainerCol className="col-xs-12 col-sm-12">
                                                    <PaginationLabels>
                                                        {this.state.paginationDetTotalVencido.primaraFilaPagina} a {this.state.paginationDetTotalVencido.ultimaFilaPagina} de {this.state.paginationDetTotalVencido.totalFilas}
                                                    </PaginationLabels>
                                                   
                                                    <PaginationButtons>
                                                        <div className="btn-group btn-group-xs" role="group">
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetTotalVencidoApi.paginationGoToFirstPage()}>
                                                                <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                                            </button>
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetTotalVencidoApi.paginationGoToPreviousPage()}>
                                                                <i className="fa fa-angle-left fa-fw"></i>Anterior
                                                            </button>
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetTotalVencidoApi.paginationGoToNextPage()}>
                                                                Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                                            </button>
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetTotalVencidoApi.paginationGoToLastPage()}>
                                                                Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                                            </button>
                                                        </div>
                                                    </PaginationButtons>
                                                </ContainerCol>
                                            </Row>
                                        </div>    
                                    </Row>
                                    
                                </ContainerCol>
                            </Row>
                        </ModalContainer>
                    </ModalResponsive>
                    <ModalResponsive   closeOut={true} open={this.state.isModalDetalleChequePendienteVisible} onClose={() => this.setState({isModalDetalleChequePendienteVisible:false})}>
                        <ModalContainer>
                            <Row>
                                <ContainerCol className='col-xs-12 col-sm-12' align="center">
                                    <h4><strong>Detalle Cheque Pendiente</strong></h4>
                                    <Hr />
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol  align="center" className="col-xs-12 col-sm-12">
                                    <Row>
                                        <ContainerCol className="col-xs-12 col-sm-12">
                                            <AgGridRender
                                                altura='150px'
                                                data={this.state.detalleChqPendiente}
                                                columnas={this.state.colDetalleChequePendiente}
                                                onGridReady={this.onGridDetalleChequePendienteReady}
                                                gridOptions={this.gridDetChequePendienteOptions}
                                                alturaRow={20}
                                            />
                                        </ContainerCol>
                                    </Row>
                                    <Row>
                                        <div className="col-xs-12 col-sm-12">
                                            <Row>
                                                <ContainerCol className="col-xs-12 col-sm-12">
                                                    <PaginationLabels>
                                                        {this.state.paginationDetChequePendiente.primaraFilaPagina} a {this.state.paginationDetChequePendiente.ultimaFilaPagina} de {this.state.paginationDetChequePendiente.totalFilas}
                                                    </PaginationLabels>
                                                   
                                                    <PaginationButtons>
                                                        <div className="btn-group btn-group-xs" role="group">
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetChequePendienteApi.paginationGoToFirstPage()}>
                                                                <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                                            </button>
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetChequePendienteApi.paginationGoToPreviousPage()}>
                                                                <i className="fa fa-angle-left fa-fw"></i>Anterior
                                                            </button>
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetChequePendienteApi.paginationGoToNextPage()}>
                                                                Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                                            </button>
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetChequePendienteApi.paginationGoToLastPage()}>
                                                                Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                                            </button>
                                                        </div>
                                                    </PaginationButtons>
                                                </ContainerCol>
                                            </Row>
                                        </div>    
                                    </Row>
                                    
                                </ContainerCol>
                            </Row>
                        </ModalContainer>
                    </ModalResponsive>
                    <ModalResponsive   closeOut={true} open={this.state.isModalDescripcionVisible} onClose={() => this.setState({isModalDescripcionVisible:false})}>
                        <ModalContainerSmall>
                            <Row>
                                <ContainerCol className='col-xs-12 col-sm-12' align="center">
                                    <h5><strong>{`Descripción: ${this.state.descripcionArt}` } </strong></h5>
                                    <h5><strong>{`Referencia: ${this.state.referencia}` } </strong></h5>
                                    <h5><strong>{`Observación: ${this.state.observacion}` } </strong></h5>
                                    <Hr />
                                </ContainerCol>
                            </Row>
                        </ModalContainerSmall>
                    </ModalResponsive>
                    <ModalResponsive   closeOut={true} open={this.state.isModalDetalleUltimosVendidosVisible} onClose={() => this.setState({isModalDetalleUltimosVendidosVisible:false})}>
                        <ModalContainer>
                            <Row>
                                <ContainerCol className='col-xs-12 col-sm-12' align="center">
                                    <h4><strong>Ultimos 6 Vendidos</strong></h4>
                                    <Hr />
                                </ContainerCol>
                                <ContainerCol className='col-xs-12 col-sm-12'>
                                    <h5>Artículo: {this.state.articuloName}</h5>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol  align="center" className="col-xs-12 col-sm-12">
                                    <Row>
                                        <ContainerCol className="col-xs-12 col-sm-12">
                                            <AgGridRender
                                                altura='150px'
                                                data={this.state.ultimosVendidos}
                                                columnas={this.state.colDetalleUltimosVendidos}
                                                onGridReady={this.onGridDetalleUltimosVendidosReady}
                                                gridOptions={this.gridDetUltimosVendidosOptions}
                                                alturaRow={20}
                                            />
                                        </ContainerCol>
                                    </Row>
                                    <Row>
                                        <div className="col-xs-12 col-sm-12">
                                            <Row>
                                                <ContainerCol className="col-xs-12 col-sm-12">
                                                    <PaginationLabels>
                                                        {this.state.paginationUltimosVendidos.primaraFilaPagina} a {this.state.paginationUltimosVendidos.ultimaFilaPagina} de {this.state.paginationUltimosVendidos.totalFilas}
                                                    </PaginationLabels>
                                                   
                                                    <PaginationButtons>
                                                        <div className="btn-group btn-group-xs" role="group">
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetUltimosVendidosApi.paginationGoToFirstPage()}>
                                                                <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                                            </button>
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetUltimosVendidosApi.paginationGoToPreviousPage()}>
                                                                <i className="fa fa-angle-left fa-fw"></i>Anterior
                                                            </button>
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetUltimosVendidosApi.paginationGoToNextPage()}>
                                                                Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                                            </button>
                                                            <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.gridDetUltimosVendidosApi.paginationGoToLastPage()}>
                                                                Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                                            </button>
                                                        </div>
                                                    </PaginationButtons>
                                                </ContainerCol>
                                            </Row>
                                        </div>    
                                    </Row>
                                    
                                </ContainerCol>
                            </Row>
                        </ModalContainer>
                    </ModalResponsive>
                    <ModalResponsive closeOut={true} open={this.state.isModalFotosVisible} onClose={() => this.setState({isModalFotosVisible:false})}>
                        {this.state.artImages.length>0?
                             <ModalContainer >
                             <ContainerCol className='col-xs-12 col-sm-12' align="center">
                                 <h4><strong>Foto: {this.state.artImages[this.state.currentImageIndex].name}</strong></h4>
                                 <Hr />
                             </ContainerCol>
 
                             <img alt="product"   src={  this.state.artImages[this.state.currentImageIndex].url }
                                                     width={'100%'} height={'70%'}/>
                             <button type="button" className="btn btn-primary btn-md" onClick={this.previousImage} >Anterior</button>
                             <button type="button" className="btn btn-primary btn-md" onClick={this.nextImage} >Siguiente</button>
                         </ModalContainer>
                         :null
                        }
                       
                    </ModalResponsive>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
        permiso: state.sesion.valoresSesionForm.Permiso,
        usuario: state.sesion.valoresSesionForm.Usuario,
        tipo_usuario: state.sesion.valoresSesionForm.TipoUsuario,
    }
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,cambiar_VisualizacionLoading}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormVende02);